<div class="inventory-route">
  <div class="inventory-view-tab-shell">
    <nav class="inventory-view-tabs" aria-label="Inventory sections">
      <button
        type="button"
        class="inventory-view-tab"
        [class.inventory-view-tab--active]="inventorySection === 'pages'"
        (click)="setInventorySection('pages')"
      >
        Pages
      </button>
      <button
        type="button"
        class="inventory-view-tab"
        [class.inventory-view-tab--active]="inventorySection === 'plan'"
        (click)="setInventorySection('plan')"
      >
        Clusters
      </button>
      <button
        type="button"
        class="inventory-view-tab"
        [class.inventory-view-tab--active]="inventorySection === 'actionPlan'"
        (click)="setInventorySection('actionPlan')"
      >
        Action plan
      </button>
      <button
        *ngIf="isActionPlanV2Enabled()"
        type="button"
        class="inventory-view-tab"
        [class.inventory-view-tab--active]="inventorySection === 'planV2'"
        (click)="setInventorySection('planV2')"
      >
        Issues
      </button>
      <button
        *ngIf="isActionPlanV2Enabled()"
        type="button"
        class="inventory-view-tab"
        [class.inventory-view-tab--active]="inventorySection === 'workItems'"
        (click)="setInventorySection('workItems')"
      >
        Work items
        <span class="badge badge--accent badge--solid badge--pill inventory-view-tab-badge" *ngIf="planV2WorkItems().length">{{ planV2WorkItems().length }}</span>
      </button>
      <button
        *ngIf="isActionPlanV2Enabled()"
        type="button"
        class="inventory-view-tab"
        [class.inventory-view-tab--active]="inventorySection === 'previous'"
        (click)="setInventorySection('previous')"
        title="Last period’s brief and commitments — compare only"
      >
        Previous
        <span class="badge badge--accent badge--solid badge--pill inventory-view-tab-badge" *ngIf="planV2PreviousItemCount()">{{ planV2PreviousItemCount() }}</span>
      </button>
      <button
        type="button"
        class="inventory-view-tab"
        [class.inventory-view-tab--active]="inventorySection === 'competing'"
        (click)="setInventorySection('competing')"
      >
        Competing pages
      </button>
    </nav>
  </div>

  <ng-container *ngIf="inventorySection === 'plan'">
    <div class="inventory-container inventory-plan-panel">
      <header class="inventory-plan-header">
        <h2 class="inventory-plan-title">Clusters</h2>
        <p class="inventory-plan-lead">
          Add parent topics or <strong>subtopics</strong> to monitor (subtopics are always listed here, even when
          <strong>Include subtopics</strong> is off on Pages). Then use <strong>Pages</strong> to assign URLs to each
          cluster.
          <a *ngIf="isClustersEnabled()" routerLink="/clusters" class="plan-clusters-link">Open Clusters organizer</a>
        </p>
      </header>

      <p class="plan-topic-loading" *ngIf="planLoading">Loading plan topics…</p>
      <p class="plan-topic-error" *ngIf="planError">{{ planError }}</p>
      <p class="plan-topic-success" *ngIf="planSuccess">{{ planSuccess }}</p>
      <p class="plan-add-topic-error" *ngIf="planAddTopicError" role="alert">{{ planAddTopicError }}</p>

      <div class="plan-empty-boot-actions" *ngIf="!planLoading && planClusters.length === 0">
        <button
          *ngIf="isClustersEnabled()"
          type="button"
          class="btn btn--accent"
          (click)="openClustersOrganizer()"
          [disabled]="!selectedDomain"
        >
          Open Clusters organizer
        </button>
        <button
          *ngIf="!isClustersEnabled()"
          type="button"
          class="btn btn--accent"
          (click)="bootstrapTopPlanTopics()"
          [disabled]="planBootstrapping || !selectedDomain"
        >
          {{ planBootstrapping ? 'Finding top topics…' : 'Find top topics' }}
        </button>
        <p class="plan-empty-boot-hint" *ngIf="isClustersEnabled()">
          Use the Clusters surface to preview topic pillars, explore assignments, and apply organization in one flow.
        </p>
        <p class="plan-empty-boot-hint" *ngIf="!isClustersEnabled()">
          Starts from top authority topics and auto-adds current core URLs. You can still add topics manually below.
        </p>
      </div>

      <div class="plan-topic-add-row">
        <label for="plan-topic-filter" class="plan-topic-add-label">Add topic</label>
        <div class="topic-typeahead plan-topic-typeahead">
          <input
            id="plan-topic-filter"
            class="input topic-filter-input"
            type="text"
            [ngModel]="planTopicSearchQuery"
            (ngModelChange)="planTopicSearchQuery = $event; onPlanTopicInputChange()"
            (focus)="onPlanTopicInputFocus()"
            (blur)="onPlanTopicInputBlur()"
            (keydown.enter)="applyPlanTopicFromInput(); $event.preventDefault()"
            placeholder="Type to search topics…"
            [disabled]="loadingTopics || !selectedDomain"
            autocomplete="off"
          />
          <div
            class="topic-suggestions plan-topic-suggestions"
            *ngIf="showPlanTopicSuggestions && !loadingTopics && visiblePlanTopicSuggestions.length > 0"
          >
            <button
              type="button"
              class="topic-suggestion"
              *ngFor="let topic of visiblePlanTopicSuggestions"
              (mousedown)="addPlanClusterFromTopic(topic)"
            >
              <span class="topic-suggestion-main">
                <span class="topic-suggestion-label">{{ topic.label }}</span>
                <span class="topic-suggestion-parent" *ngIf="topic.topicType === 'child'">in {{ topic.parentLabel }}</span>
              </span>
              <span class="topic-suggestion-tags">
                <span class="badge topic-kind-tag" [ngClass]="topicKindTagClass(topic)">
                  {{ topic.topicType === 'child' ? 'Child' : 'Parent' }}
                </span>
                <span class="badge topic-authority-tag" [ngClass]="topicAuthorityTagClass(topic.authorityScore)">
                  {{ formatAuthorityScore(topic.authorityScore) }}
                </span>
              </span>
            </button>
          </div>
        </div>
        <button
          type="button"
          class="btn btn--bare btn--sm"
          (click)="applyPlanTopicFromInput()"
          [disabled]="loadingTopics || planLoading || !selectedDomain || !planTopicSearchQuery.trim()"
        >
          Add
        </button>
      </div>
      <p class="plan-topic-loading" *ngIf="loadingTopics">Loading topics…</p>
      <p class="plan-topic-error" *ngIf="!loadingTopics && topicError">{{ topicError }}</p>

      <p class="plan-empty-message" *ngIf="!loadingTopics && !topicError && !planLoading && planClusters.length === 0">
        No topics on your plan yet. Search above — parents and subtopics from Domain Topics are available.
      </p>

      <ul class="plan-cluster-list" *ngIf="!planLoading && planClusters.length > 0">
        <li class="card card--pad plan-cluster-card" *ngFor="let c of planClusters; trackBy: trackPlanCluster">
          <div class="card card--pad plan-cluster-head">
            <div class="plan-cluster-titles">
              <ng-container *ngIf="editingPlanTopicId !== c.id; else editPlanLabel">
                <span class="plan-cluster-label">{{ c.label }}</span>
              </ng-container>
              <ng-template #editPlanLabel>
                <div class="plan-cluster-label-edit">
                  <input
                    type="text"
                    class="input plan-cluster-label-input"
                    [ngModel]="planTopicLabelDraft[c.id] || ''"
                    (ngModelChange)="planTopicLabelDraft[c.id] = $event"
                    (keydown.enter)="savePlanClusterLabel(c); $event.preventDefault()"
                    [disabled]="savingPlanTopicLabelId === c.id"
                  />
                  <button
                    type="button"
                    class="btn btn--sm"
                    (click)="savePlanClusterLabel(c)"
                    [disabled]="savingPlanTopicLabelId === c.id || !(planTopicLabelDraft[c.id] || '').trim()"
                  >
                    {{ savingPlanTopicLabelId === c.id ? 'Saving…' : 'Save' }}
                  </button>
                  <button
                    type="button"
                    class="btn btn--sm"
                    (click)="cancelRenamePlanCluster(c.id)"
                    [disabled]="savingPlanTopicLabelId === c.id"
                  >
                    Cancel
                  </button>
                </div>
              </ng-template>
              <span class="plan-cluster-slug">{{ c.topicSlug }}</span>
            </div>
            <span class="plan-cluster-count">{{ c.urls.length }} URL{{ c.urls.length === 1 ? '' : 's' }}</span>
            <button
              type="button"
              class="btn plan-cluster-rename"
              (click)="beginRenamePlanCluster(c)"
              [disabled]="planLoading || savingPlanTopicLabelId === c.id || editingPlanTopicId === c.id"
            >
              Rename
            </button>
            <button type="button" class="btn plan-cluster-remove" (click)="removePlanCluster(c.id)" [disabled]="planLoading">
              Remove
            </button>
          </div>

          <div class="plan-cluster-actions">
            <button
              type="button"
              class="btn btn--accent btn--sm"
              (click)="findUrlsForTopic(c)"
              [disabled]="findingUrlsTopicId === c.id || planLoading"
            >
              {{ findingUrlsTopicId === c.id ? 'Finding URLs…' : 'Find URLs about this topic' }}
            </button>
            <div class="plan-cluster-find-other">
              <div class="topic-typeahead plan-cluster-find-other-typeahead">
                <input
                  type="text"
                  class="input plan-cluster-find-other-input"
                  [ngModel]="planFindOtherTopicInput[c.id] || ''"
                  (ngModelChange)="onPlanFindOtherTopicInputChange(c.id, $event)"
                  (focus)="onPlanFindOtherTopicInputFocus(c.id)"
                  (blur)="onPlanFindOtherTopicInputBlur(c.id)"
                  (keydown.enter)="findUrlsForAnotherTopic(c); $event.preventDefault()"
                  placeholder="Find URLs about another topic…"
                  [disabled]="findingUrlsTopicId === c.id || planLoading"
                  autocomplete="off"
                />
                <div
                  class="topic-suggestions plan-cluster-find-other-suggestions"
                  *ngIf="planFindOtherTopicSuggestionsOpen[c.id] && !loadingTopics && visiblePlanOtherTopicSuggestions(c.id).length > 0"
                >
                  <button
                    type="button"
                    class="topic-suggestion"
                    *ngFor="let topic of visiblePlanOtherTopicSuggestions(c.id)"
                    (mousedown)="selectPlanOtherTopicSuggestion(c.id, topic)"
                  >
                    <span class="topic-suggestion-main">
                      <span class="topic-suggestion-label">{{ topic.label }}</span>
                      <span class="topic-suggestion-parent" *ngIf="topic.topicType === 'child'">in {{ topic.parentLabel }}</span>
                    </span>
                    <span class="topic-suggestion-tags">
                      <span class="badge topic-kind-tag" [ngClass]="topicKindTagClass(topic)">
                        {{ topic.topicType === 'child' ? 'Child' : 'Parent' }}
                      </span>
                      <span class="badge topic-authority-tag" [ngClass]="topicAuthorityTagClass(topic.authorityScore)">
                        {{ formatAuthorityScore(topic.authorityScore) }}
                      </span>
                    </span>
                  </button>
                </div>
              </div>
              <button
                type="button"
                class="btn btn--sm"
                (click)="findUrlsForAnotherTopic(c)"
                [disabled]="findingUrlsTopicId === c.id || planLoading || !(planFindOtherTopicInput[c.id] || '').trim()"
              >
                {{ findingUrlsTopicId === c.id ? 'Finding URLs…' : 'Find URLs about another topic' }}
              </button>
            </div>
          </div>

          <div class="table-wrapper plan-cluster-table-wrapper" *ngIf="c.urls.length > 0">
            <table class="table table--dense inventory-table plan-cluster-table">
              <thead>
                <tr>
                  <th class="plan-col-move-select">
                    <span class="visually-hidden">Select URL to move</span>
                  </th>
                  <th class="col-url">URL</th>
                  <th class="col-score">Score</th>
                  <th class="col-issues">Issues</th>
                  <th class="col-topics">Topics</th>
                  <th class="col-topic-class">
                    <button type="button" class="btn btn--bare btn--sm" (click)="togglePlanClassSortDirection()">
                      Class {{ planClassSortDirection === 'default' ? '↓' : '↑' }}
                    </button>
                  </th>
                  <th class="col-topic-relevance">Relevance</th>
                  <th class="col-topic-weight">Weight</th>
                  <th class="col-keywords">Keywords</th>
                  <th class="col-traffic">Est. Traffic</th>
                  <th class="plan-col-source">Source</th>
                  <th class="plan-col-action">Action</th>
                </tr>
              </thead>
              <tbody *ngIf="sortedPlanClusterUrls(c) as clusterRows">
                <tr *ngFor="let u of clusterRows; let i = index">
                  <td class="plan-col-move-select">
                    <input
                      type="checkbox"
                      [checked]="isPlanMoveSelected(c.id, u.urlId)"
                      (click)="onPlanMoveCheckboxClick(c.id, clusterRows, i, { urlId: u.urlId, url: u.url }, $event)"
                      [attr.aria-label]="'Select URL to move: ' + u.url"
                    />
                  </td>
                  <td class="col-url" [title]="u.url">
                    <a
                      class="url-text external-link"
                      [href]="u.url"
                      target="_blank"
                      rel="noopener noreferrer"
                      (click)="$event.stopPropagation()"
                    >
                      {{ formatUrl(u.url, true) }}
                      <span class="visually-hidden"> (opens in a new tab)</span>
                    </a>
                  </td>
                  <td class="col-score">
                    <span class="badge" [ngClass]="scoreClass((u.onpageScore ?? 0))">
                      <span [class.cell-empty]="u.onpageScore == null">{{ u.onpageScore ?? '—' }}</span>
                    </span>
                  </td>
                  <td class="col-issues">
                    <span class="issues-badge issues-badge--icons">
                      <span
                        class="badge badge--pill badge--danger issue-pill"
                        *ngIf="(u.criticalIssuesCount || 0) > 0"
                        [title]="(u.criticalIssuesCount || 0) + ' critical issue' + ((u.criticalIssuesCount || 0) === 1 ? '' : 's')"
                      >
                        <span class="issue-pill-icon" aria-hidden="true">⛔</span>
                        <span>{{ u.criticalIssuesCount }}</span>
                      </span>
                      <span
                        class="badge badge--pill badge--warning issue-pill"
                        *ngIf="(u.warningsCount || 0) > 0"
                        [title]="(u.warningsCount || 0) + ' warning' + ((u.warningsCount || 0) === 1 ? '' : 's')"
                      >
                        <span class="issue-pill-icon" aria-hidden="true">⚠</span>
                        <span>{{ u.warningsCount }}</span>
                      </span>
                      <span
                        class="badge badge--pill badge--success issue-pill"
                        *ngIf="(u.criticalIssuesCount || 0) === 0 && (u.warningsCount || 0) === 0"
                        title="No critical issues or warnings"
                      >
                        Clean
                      </span>
                    </span>
                  </td>
                  <td class="col-topics"><span [class.cell-empty]="u.topicSignalsCount == null">{{ u.topicSignalsCount ?? '—' }}</span></td>
                  <td class="col-topic-class">
                    <div class="plan-class-cell" data-plan-class-menu-root>
                      <button
                        type="button"
                        class="badge topic-class-badge plan-class-badge-trigger"
                        [ngClass]="topicClassBadgeClass(u.topicClass)"
                        (click)="togglePlanClassMenu(c.id, u.urlId, $event)"
                        [disabled]="isPlanClassUpdating(c.id, u.urlId)"
                      >
                        {{ topicClassLabel(u.topicClass) }}
                      </button>
                      <div class="plan-class-menu" *ngIf="isPlanClassMenuOpen(c.id, u.urlId)">
                        <button type="button" class="plan-class-menu-item" (click)="updatePlanUrlClass(c, u, 'auto')">Auto</button>
                        <button type="button" class="plan-class-menu-item" (click)="updatePlanUrlClass(c, u, 'core')">Core</button>
                        <button type="button" class="plan-class-menu-item" (click)="updatePlanUrlClass(c, u, 'supporting')">Supporting</button>
                        <button type="button" class="plan-class-menu-item" (click)="updatePlanUrlClass(c, u, 'mention')">Mention</button>
                      </div>
                    </div>
                  </td>
                  <td class="col-topic-relevance">
                    <span class="badge" [ngClass]="topicWeightClass(u.topicRelevanceScore)">
                      {{ formatTopicRelevancePct(u.topicRelevancePct) }}
                    </span>
                  </td>
                  <td class="col-topic-weight">
                    <span class="badge" [ngClass]="topicWeightClass(u.topicWeight)">
                      {{ formatTopicWeight(u.topicWeight) }}
                    </span>
                  </td>
                  <td class="col-keywords"><span [class.cell-empty]="u.rankedKeywordsCount == null">{{ u.rankedKeywordsCount ?? '—' }}</span></td>
                  <td class="col-traffic"><span [class.cell-empty]="u.estimatedOrganicTraffic == null">{{ u.estimatedOrganicTraffic != null ? (u.estimatedOrganicTraffic | number:'1.0-0') : '—' }}</span></td>
                  <td class="plan-col-source"><span class="plan-cluster-url-source">{{ u.source }}</span></td>
                  <td class="plan-col-action">
                    <div class="plan-col-actions">
                      <button type="button" class="btn btn--sm" (click)="removeUrlFromCluster(c, u.urlId)">
                        Remove
                      </button>
                      <button
                        type="button"
                        class="btn btn--sm"
                        (click)="excludePlanUrl(u)"
                        [disabled]="isUpdatingInclusion"
                      >
                        Exclude
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="plan-cluster-move-actions" *ngIf="planMoveSelectionCount(c.id) > 0">
            <span class="plan-cluster-move-summary">{{ planMoveSelectionCount(c.id) }} URL{{ planMoveSelectionCount(c.id) === 1 ? '' : 's' }} selected</span>
            <label class="plan-cluster-move-label" [attr.for]="'plan-move-target-' + c.id">Move to cluster</label>
            <select
              class="input plan-cluster-move-select"
              [id]="'plan-move-target-' + c.id"
              [ngModel]="planMoveTargetClusterIdBySource[c.id] || ''"
              (ngModelChange)="planMoveTargetClusterIdBySource[c.id] = $event"
              [disabled]="isMovingPlanCluster(c.id)"
            >
              <option value="">Choose destination…</option>
              <option *ngFor="let target of planMoveTargetsForCluster(c.id)" [ngValue]="target.id">{{ target.label }}</option>
            </select>
            <button
              type="button"
              class="btn btn--accent btn--sm"
              (click)="confirmMoveSelectedUrls(c)"
              [disabled]="isMovingPlanCluster(c.id) || !(planMoveTargetClusterIdBySource[c.id] || '').trim()"
            >
              {{ isMovingPlanCluster(c.id) ? 'Moving…' : 'Move selected' }}
            </button>
            <button
              type="button"
              class="btn btn--sm"
              (click)="clearPlanMoveSelection(c.id)"
              [disabled]="isMovingPlanCluster(c.id)"
            >
              Clear
            </button>

            <label class="plan-cluster-move-label" [attr.for]="'plan-bulk-class-' + c.id">Set class</label>
            <select
              class="input plan-cluster-move-select"
              [id]="'plan-bulk-class-' + c.id"
              [ngModel]="planBulkClassByCluster[c.id] || 'auto'"
              (ngModelChange)="planBulkClassByCluster[c.id] = $event"
              [disabled]="isPlanClassUpdating(c.id)"
            >
              <option value="auto">Auto</option>
              <option value="core">Core</option>
              <option value="supporting">Supporting</option>
              <option value="mention">Mention</option>
            </select>
            <button
              type="button"
              class="btn btn--sm"
              (click)="updateSelectedPlanUrlsClass(c)"
              [disabled]="isPlanClassUpdating(c.id)"
            >
              {{ isPlanClassUpdating(c.id) ? 'Applying…' : 'Apply class' }}
            </button>
            <button
              type="button"
              class="btn btn--sm"
              (click)="excludeSelectedPlanUrls(c)"
              [disabled]="isUpdatingInclusion || isMovingPlanCluster(c.id)"
            >
              {{ isUpdatingInclusion ? 'Saving…' : 'Mark excluded' }}
            </button>
          </div>
          <p class="plan-cluster-urls-empty" *ngIf="c.urls.length === 0">No pages added yet — select rows on Pages and use “Add to cluster…”.</p>

          <div class="plan-cluster-candidates" *ngIf="hasPlanUrlRows(c.id)">
            <p class="plan-cluster-candidates-title">Found URLs (click Add to attach)</p>
            <ul class="plan-candidate-list">
              <li *ngFor="let row of planUrlRows(c.id); trackBy: trackPlanTopicCandidateRow" class="plan-candidate-item">
                <a
                  class="plan-candidate-url external-link"
                  [href]="row.url"
                  target="_blank"
                  rel="noopener noreferrer"
                  [title]="row.url"
                  (click)="$event.stopPropagation()"
                >
                  {{ row.url }}
                  <span class="visually-hidden"> (opens in a new tab)</span>
                </a>
                <span class="badge topic-class-badge" [ngClass]="topicClassBadgeClass(row.topicClass)">
                  {{ topicClassLabel(row.topicClass) }}
                </span>
                <button
                  type="button"
                  class="btn btn--sm"
                  (click)="addCandidateUrlToCluster(c, row)"
                  [disabled]="clusterHasUrl(c, row.url)"
                >
                  {{ clusterHasUrl(c, row.url) ? 'Added' : 'Add' }}
                </button>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </ng-container>

  <ng-container *ngIf="inventorySection === 'actionPlan'">
    <div class="inventory-container">
      <header class="inventory-plan-header">
        <h2 class="inventory-plan-title">Action plan</h2>
        <p class="inventory-plan-lead">
          Specific internal-link and cluster-management tasks generated from topic fit, link gaps, and inventory coverage.
        </p>
      </header>

      <div class="action-plan-controls">
        <button type="button" class="btn btn--sm" (click)="refreshActionPlanSuggestions()" [disabled]="actionPlanLoading || !selectedDomain">
          {{ actionPlanLoading ? 'Refreshing…' : 'Refresh suggestions' }}
        </button>
        <button
          type="button"
          class="btn btn--sm"
          (click)="exportActionPlanPdf()"
          [disabled]="actionPlanLoading || actionPlanExporting || !selectedDomain || (actionPlanTargetGroups.length === 0 && actionPlanUnclusteredRows.length === 0 && actionPlanClusterSummaries.length === 0)"
        >
          {{ actionPlanExporting ? 'Exporting…' : 'Export PDF' }}
        </button>
        <label class="action-plan-toggle">
          <input type="checkbox" [checked]="actionPlanIncludeDone" (change)="toggleActionPlanIncludeDone()" />
          <span>Show done</span>
        </label>
        <label class="action-plan-toggle">
          <input type="checkbox" [checked]="actionPlanIncludeDismissed" (change)="toggleActionPlanIncludeDismissed()" />
          <span>Show dismissed</span>
        </label>
      </div>

      <p class="plan-topic-loading" *ngIf="actionPlanLoading">Loading action plan suggestions…</p>
      <p class="plan-topic-error" *ngIf="actionPlanError">{{ actionPlanError }}</p>

      <p class="plan-empty-message" *ngIf="!selectedDomain && !actionPlanLoading">
        Select an active domain to view action plan suggestions.
      </p>

      <p class="plan-empty-message" *ngIf="selectedDomain && !actionPlanLoading && !actionPlanError && actionPlanRows.length === 0 && actionPlanUnclusteredRows.length === 0 && actionPlanClusterSummaries.length === 0">
        No action-plan suggestions for current filters.
      </p>

      <section class="action-plan-cluster-overview" *ngIf="!actionPlanLoading && actionPlanClusterSummaries.length > 0">
        <header class="action-plan-cluster-management-head">
          <h3>Cluster overview</h3>
          <p>Cluster structure grouped by role and sorted by estimated traffic.</p>
        </header>
        <table class="table table--dense action-plan-table-compact--clusters">
          <thead>
            <tr>
              <th>Cluster name</th>
              <th>Core pages</th>
              <th>Supporting pages</th>
            </tr>
          </thead>
          <tbody *ngFor="let cluster of actionPlanClusterSummaries">
            <tr>
              <td>{{ cluster.label }}</td>
              <td>
                <textarea
                  class="action-plan-edit-sentence action-plan-cluster-description"
                  [value]="getActionPlanClusterDescription(cluster)"
                  (input)="onActionPlanClusterDescriptionChange(cluster, $any($event.target).value)"
                  rows="2"
                  placeholder="Description for this cluster (shown in report)"
                ></textarea>
                <div class="cell-empty" *ngIf="getActionPlanClusterCorePages(cluster).length === 0">—</div>
                <div *ngFor="let page of getActionPlanClusterCorePages(cluster)">
                  <a class="url-text external-link" [href]="page.url" target="_blank" rel="noopener noreferrer">
                    {{ formatUrl(page.url, false) }}
                  </a>
                  <span class="badge badge--pill action-plan-traffic-pill">{{ page.estimatedOrganicTraffic | number:'1.0-0' }}</span>
                </div>
              </td>
              <td>
                {{ getActionPlanClusterSupportingPages(cluster).length }} supporting page{{ getActionPlanClusterSupportingPages(cluster).length === 1 ? '' : 's' }} in this cluster
              </td>
            </tr>
          </tbody>
        </table>
      </section>

      <section class="action-plan-cluster-management" *ngIf="!actionPlanLoading && actionPlanUnclusteredRows.length > 0">
        <header class="action-plan-cluster-management-head">
          <h3>Cluster management · Unclustered pages</h3>
          <p>Pages not in any cluster, prioritized by traffic and ICP-fit action.</p>
        </header>
        <table class="table table--dense action-plan-table-compact--clusters">
          <thead>
            <tr>
              <th>URL</th>
              <th>Est. traffic</th>
              <th>Recommendation</th>
              <th>Top topics</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody *ngFor="let row of actionPlanUnclusteredRows; trackBy: trackActionPlanRow">
            <tr>
              <td>
                <a class="url-text external-link" [href]="row.url" target="_blank" rel="noopener noreferrer">
                  {{ formatUrl(row.url, false) }}
                </a>
              </td>
              <td>{{ row.estimatedOrganicTraffic | number:'1.0-0' }}</td>
              <td>
                <input
                  type="text"
                  class="input action-plan-edit-input"
                  [value]="getActionPlanEditedRecommendationText(row)"
                  (input)="onActionPlanRecommendationChange(row, $any($event.target).value)"
                />
              </td>
              <td>
                <span *ngIf="row.topTopics.length > 0; else noTopics">{{ row.topTopics.join(', ') }}</span>
                <ng-template #noTopics><span class="cell-empty">—</span></ng-template>
              </td>
              <td>
                <div class="action-plan-row-actions">
                  <span class="action-plan-status" [ngClass]="actionPlanStatusClass(row.status)">
                    {{ actionPlanStatusLabel(row.status) }}
                  </span>
                  <button
                    *ngIf="row.status !== 'done'"
                    type="button"
                    class="btn btn--sm"
                    (click)="updateUnclusteredPageSuggestionStatus(row, 'done')"
                    [disabled]="actionPlanUpdatingKey === row.suggestionKey"
                  >
                    Mark done
                  </button>
                  <button
                    *ngIf="row.status !== 'dismissed'"
                    type="button"
                    class="btn btn--sm"
                    (click)="updateUnclusteredPageSuggestionStatus(row, 'dismissed')"
                    [disabled]="actionPlanUpdatingKey === row.suggestionKey"
                  >
                    Dismiss
                  </button>
                  <button
                    *ngIf="row.status !== 'open'"
                    type="button"
                    class="btn btn--sm"
                    (click)="updateUnclusteredPageSuggestionStatus(row, 'open')"
                    [disabled]="actionPlanUpdatingKey === row.suggestionKey"
                  >
                    Reopen
                  </button>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="5">
                <div class="action-plan-cluster-rationale">{{ row.rationale }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </section>

      <div class="action-plan-groups" *ngIf="!actionPlanLoading && actionPlanRows.length > 0">
        <section class="action-plan-group" *ngFor="let group of actionPlanTargetGroups; trackBy: trackActionPlanTargetGroup">
          <header class="action-plan-group-head">
            <h3 class="action-plan-group-title">
              <span class="action-plan-group-label">Target:</span>
              <a class="url-text external-link" [href]="group.targetUrl" target="_blank" rel="noopener noreferrer">
                {{ formatUrl(group.targetUrl, false) }}
              </a>
            </h3>
            <div class="action-plan-group-meta">
              <span class="badge badge--pill" [ngClass]="scoreClass(group.maxScore)">Top priority {{ group.maxScore | number:'1.0-0' }}</span>
              <span class="badge badge--pill">Est. traffic {{ group.targetTraffic | number:'1.0-0' }}</span>
              <span class="badge badge--pill">{{ group.rows.length }} source suggestion{{ group.rows.length === 1 ? '' : 's' }}</span>
              <button
                type="button"
                class="btn btn--sm"
                (click)="deleteActionPlanTarget(group)"
              >
                Delete
              </button>
              <button
                type="button"
                class="btn btn--sm action-plan-group-toggle"
                (click)="toggleActionPlanGroupCollapsed(group)"
              >
                {{ isActionPlanGroupCollapsed(group) ? 'Expand' : 'Collapse' }}
              </button>
            </div>
          </header>

          <div class="action-plan-source-list" *ngIf="!isActionPlanGroupCollapsed(group)">
            <table class="table table--dense">
              <thead>
                <tr>
                  <th>Link from</th>
                  <th>Suggested anchor</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody *ngFor="let row of group.rows; trackBy: trackActionPlanRow">
                <tr>
                  <td>
                    <a class="url-text external-link" [href]="row.sourceUrl" target="_blank" rel="noopener noreferrer">
                      {{ formatUrl(row.sourceUrl, false) }}
                    </a>
                  </td>
                  <td>
                    <input
                      type="text"
                      class="input action-plan-edit-input"
                      [value]="getActionPlanEditedAnchor(row)"
                      (input)="onActionPlanAnchorChange(row, $any($event.target).value)"
                      placeholder="Anchor text"
                    />
                    <span class="badge action-plan-row-score" [ngClass]="scoreClass(row.score)">
                      {{ row.score | number:'1.0-0' }}
                    </span>
                  </td>
                  <td>
                    <div class="action-plan-row-actions">
                      <span class="action-plan-status" [ngClass]="actionPlanStatusClass(row.status)">
                        {{ actionPlanStatusLabel(row.status) }}
                      </span>
                      <button
                        type="button"
                        class="btn btn--sm"
                        (click)="toggleActionPlanWhyExpanded(row)"
                      >
                        {{ isActionPlanWhyExpanded(row) ? 'Hide why' : 'Why?' }}
                      </button>
                      <button
                        *ngIf="row.status !== 'dismissed'"
                        type="button"
                        class="btn btn--sm"
                        (click)="updateActionPlanSuggestionStatus(row, 'dismissed')"
                        [disabled]="actionPlanUpdatingKey === row.suggestionKey"
                      >
                        Dismiss
                      </button>
                      <button
                        *ngIf="row.status === 'dismissed'"
                        type="button"
                        class="btn btn--sm"
                        (click)="updateActionPlanSuggestionStatus(row, 'open')"
                        [disabled]="actionPlanUpdatingKey === row.suggestionKey"
                      >
                        Reopen
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="3">
                    <textarea
                      class="action-plan-edit-sentence"
                      [value]="getActionPlanEditedSentence(row)"
                      (input)="onActionPlanSentenceChange(row, $any($event.target).value)"
                      rows="2"
                      placeholder="Example sentence"
                    ></textarea>
                  </td>
                </tr>
                <tr *ngIf="isActionPlanWhyExpanded(row)">
                  <td colspan="3">
                    <div class="action-plan-why-details">
                      <div class="action-plan-where-topic">Matched topic: <strong>{{ row.matchedTopic }}</strong></div>
                      <p class="action-plan-where-rationale" *ngIf="row.where.rationale">{{ row.where.rationale }}</p>
                      <ul class="action-plan-reasons">
                        <li *ngFor="let reason of row.reasons">{{ reason }}</li>
                      </ul>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="inventorySection === 'planV2' && isActionPlanV2Enabled()">
    <div class="inventory-container inventory-plan-v2-panel">
      <header class="inventory-plan-header">
        <h2 class="inventory-plan-title">Living brief</h2>
        <p class="inventory-plan-period" *ngIf="planV2Period as period" [title]="planV2PeriodHint()">
          {{ period.label }}
        </p>
        <!-- Hidden pages announce themselves, in the header.
             The toggle that reveals them sits in a toolbar 1,600px down —
             below the packages strip, unticked — which from the top of the
             page is indistinguishable from the pages not existing. The person
             who needs it is the one who noticed something went missing, and
             they are looking for a way in, not a checkbox. -->
        <p class="plan-v2-hidden-notice" *ngIf="!planV2Loading && !planV2ShowIgnored && planV2HiddenPageCount() > 0">
          <strong>{{ planV2HiddenPageCount() }}</strong>
          {{ planV2HiddenPageCount() === 1 ? 'page is' : 'pages are' }} hidden from this period’s queue —
          put aside, or carrying cards you dismissed.
          <button type="button" class="btn btn--sm" (click)="planV2RevealHidden()">Show them</button>
        </p>
        <p class="inventory-plan-lead" *ngIf="planV2Summary && !planV2Loading">
          This period’s queue — <strong>{{ planV2AttentionCount() }}</strong> URLs need your attention.
          Expand a row to open the review drawer, dismiss what is not a problem, or
          <button type="button" class="btn btn--bare" (click)="openWorkItemsTab()">send cards to Work items</button>.
        </p>
        <p class="inventory-plan-lead muted" *ngIf="!planV2Summary && !planV2Loading">
          This period’s queue. Review synthesized findings per URL and send actionable cards to Work items
          for execution.
        </p>
        <p class="inventory-plan-lead muted" *ngIf="planV2HasPreviousPeriod()">
          What you accepted or dismissed before this period began is kept in
          <button type="button" class="btn btn--bare" (click)="openPreviousTab()">Previous</button>
          for compare — it is not part of this brief.
        </p>
      </header>

      <!--
        IB3 — the same packages the Dashboard shows, from the same route and the
        same component, rendered verbatim. The per-card "Open in Issues" link is
        off here: it points at this page. The full queue below is that drill-down.
      -->
      <app-impact-packages
        *ngIf="!impactBriefLoading && hasImpactBrief()"
        [packages]="impactBrief!.packages"
        [reviewFillPackages]="impactBrief!.reviewFillPackages ?? []"
        [headline]="impactBrief!.headline"
        [readiness]="impactBrief!.readiness"
        [emptyState]="impactBrief!.emptyState"
        [mode]="impactBrief!.mode"
        [totals]="impactBrief!.totals"
        [showOpenInIssues]="false"
        [domain]="selectedDomain"
        [expandingPackageId]="expandingPackageId"
        (expandPackage)="expandImpactPackage($event)"
        subhead="The biggest things to work on this period. The full queue is below."
      ></app-impact-packages>

      <div class="action-plan-controls plan-v2-queue-controls">
        <button
          type="button"
          class="btn btn--sm"
          (click)="loadPlanV2()"
          [disabled]="planV2Loading || !selectedDomain"
        >
          {{ planV2Loading ? 'Refreshing…' : 'Refresh' }}
        </button>
        <button
          type="button"
          class="btn btn--sm"
          (click)="planV2RegenerateQueue()"
          [disabled]="planV2Regenerating || planV2TriagePersistedCount() === 0 || !selectedDomain"
          title="Resets this period’s triage only — ignored URLs, dismissed cards and work items saved this period. Previous history is kept."
        >
          {{ planV2Regenerating ? 'Regenerating…' : 'Regenerate queue' }}
        </button>
        <label class="plan-v2-actions-only-toggle">
          <input type="checkbox" [(ngModel)]="planV2ActionsOnly" />
          Actions only
        </label>
        <!-- Gates BOTH restore lists. Keyed on ignored rows alone, the toggle
             vanished on a domain whose only hidden pages were card dismissals,
             taking the one way back with it. -->
        <label class="plan-v2-actions-only-toggle" *ngIf="planV2HiddenPageCount() > 0">
          <input type="checkbox" [(ngModel)]="planV2ShowIgnored" />
          Show hidden ({{ planV2HiddenPageCount() }})
        </label>
      </div>

      <p class="plan-topic-loading" *ngIf="planV2Loading">Loading Plan v2…</p>
      <p class="plan-topic-error" *ngIf="planV2Error">{{ planV2Error }}</p>

      <section class="card card--pad plan-v2-summary" *ngIf="planV2Summary && !planV2Loading" aria-label="Executive summary">
        <div class="plan-v2-summary-head">
          <h3 class="plan-v2-summary-title">Executive summary</h3>
          <span class="plan-v2-summary-queue muted">
            Open queue
            <strong>{{ planV2AttentionCount() }}</strong>
            / {{ planV2Summary.totalUrlsInPool }} in pool
            <span *ngIf="planV2Summary.leftOutPageCount" [title]="planV2Summary.leftOutNote || ''">
              · {{ planV2Summary.leftOutPageCount }} not live in the latest crawl</span
            >
            <span *ngIf="planV2IgnoredRows().length"> · {{ planV2IgnoredRows().length }} ignored</span>
          </span>
        </div>
        <div class="plan-v2-summary-stats">
          <span class="plan-v2-stat"><span class="plan-v2-stat-tier">P0</span> Technical <strong>{{ planV2Summary.p0Technical }}</strong></span>
          <span class="plan-v2-stat"><span class="plan-v2-stat-tier">P1</span> Consolidate <strong>{{ planV2Summary.p1Consolidate }}</strong></span>
          <span class="plan-v2-stat"><span class="plan-v2-stat-tier">P2</span> Gap <strong>{{ planV2Summary.p2Gap }}</strong></span>
          <span class="plan-v2-stat"><span class="plan-v2-stat-tier">P3</span> Intent <strong>{{ planV2Summary.p3Intent }}</strong></span>
          <span class="plan-v2-stat"><span class="plan-v2-stat-tier">P4</span> Links <strong>{{ planV2Summary.p4Links }}</strong></span>
          <span class="plan-v2-stat"><span class="plan-v2-stat-tier">P5</span> Cluster <strong>{{ planV2Summary.p5Cluster }}</strong></span>
        </div>
        <p class="plan-v2-summary-themes" *ngIf="planV2Summary.themes?.length">
          <span class="plan-v2-theme" *ngFor="let theme of planV2Summary.themes">{{ theme }}</span>
        </p>
      </section>

      <p class="plan-empty-message" *ngIf="!planV2Loading && !planV2Error && planV2Rows.length === 0 && selectedDomain">
        No open synthesis items for this domain.
      </p>

      <p
        class="plan-empty-message"
        *ngIf="!planV2Loading && !planV2Error && planV2Rows.length > 0 && planV2ActiveRows().length === 0"
      >
        All URLs on this page are ignored.
        <button type="button" class="btn btn--bare" (click)="planV2ShowIgnored = true">Show hidden</button>
        or use <strong>Regenerate queue</strong> to reset this period’s triage (including this period’s work items).
      </p>

      <div class="table-wrapper table-wrapper--pages-sticky" *ngIf="!planV2Loading && planV2ActiveRows().length > 0">
        <table class="table table--dense plan-v2-table">
          <thead>
            <tr>
              <th [title]="planV2OpportunityColumnHint">Opportunity</th>
              <th [title]="planV2PriorityTierHint">Tier</th>
              <th [title]="planV2ChangeColumnHint">Change</th>
              <th>URL</th>
              <th>Recommended action</th>
              <th>Signals</th>
              <th>Gap / health</th>
              <th [title]="realizationRatioColumnHint">Ratio</th>
              <th [title]="serpKeywordDifficultyColumnHint">KD</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let row of planV2ActiveRows(); trackBy: trackPlanV2Row">
              <tr
                class="plan-v2-row"
                [class.plan-v2-row--ignoring]="planV2IgnoringUrlId === row.urlId"
                [class.plan-v2-row--drawer-open]="isPlanV2DrawerOpenFor(row)"
              >
                <td [title]="planV2OpportunityTitle(row)">
                  <span class="badge" [ngClass]="scoreClass(row.opportunityScore)">{{ row.opportunityScore | number:'1.0-0' }}</span>
                </td>
                <td [title]="planV2PriorityTierHint">
                  <span class="badge badge--muted">{{ planV2DisplayTier(row) | number:'1.0-0' }}</span>
                </td>
                <td class="col-plan-v2-change" [title]="planV2ChangeTitle(row)">
                  <span
                    class="badge"
                    [ngClass]="planV2ChangeClass(row)"
                    *ngIf="row.periodChange; else planV2NoChange"
                  >{{ planV2ChangeLabel(row) }}</span>
                  <ng-template #planV2NoChange><span class="muted">—</span></ng-template>
                </td>
                <td class="plan-v2-url-cell" [title]="row.url">{{ planV2UrlLabel(row) }}</td>
                <td>
                  <strong>{{ row.recommendedAction.label }}</strong>
                  <span class="plan-v2-change-evidence muted" *ngIf="row.periodChange">
                    {{ row.periodChange.evidence }}
                  </span>
                  <!-- The pair item: the review surface's Cannibalization card for this page, word for word
                       (A's engine, B's verdict; on estimates E's warning ends it). -->
                  <ng-container *ngIf="row.cannibal as pair">
                    <span class="plan-v2-pair-item" [title]="pair.why">{{ pair.action }}</span>
                    <span class="plan-v2-pair-item muted" [title]="planV2PairSearchesTitle(pair)">{{ planV2PairSearchesLabel(pair) }}</span>
                    <span class="plan-v2-pair-item muted">{{ pair.evidenceSourceLine }}</span>
                  </ng-container>
                </td>
                <td>
                  <span
                    *ngFor="let kind of row.signalTypes"
                    class="badge badge--pill page-signal-chip"
                    [ngClass]="pageSignalChipClass(kind)"
                    [title]="planV2SignalTooltip(kind, row)"
                  >{{ planV2SignalLabel(kind) }}</span>
                </td>
                <td>
                  <span class="badge health-pill" [ngClass]="planV2HealthClass(row.metrics.effectiveHealth)">{{ row.metrics.effectiveHealth }}</span>
                  <span class="muted plan-v2-gap" *ngIf="row.metrics.realizationGap !== null">
                    Gap {{ row.metrics.realizationGap | number:'1.0-0' }}
                  </span>
                </td>
                <td class="col-realization-ratio" [title]="planV2RealizationRatioTitle(row)">
                  {{ planV2RealizationRatioLabel(row) }}
                </td>
                <td class="col-serp-kd" [title]="planV2SerpKeywordDifficultyTitle(row)">
                  {{ planV2SerpKeywordDifficultyLabel(row) }}
                </td>
                <!-- I2: one action, not three. URL detail and Ignore URL both
                     already exist in the drawer this button opens, so stacking
                     them here made every row three rows tall to offer nothing
                     new. -->
                <td class="plan-v2-row-actions">
                  <button type="button" class="btn btn--sm" (click)="togglePlanV2Drawer(row, $event)">
                    {{ isPlanV2DrawerOpenFor(row) ? 'Close' : 'Expand' }}
                  </button>
                </td>
              </tr>
            </ng-container>
            <!-- The third restore case, beside the one it belongs with.
                 A page whose only decision was a dismissed card is not a work
                 item and not an ignored URL, so neither list above offers it.
                 Its page returns to review on its own now; its CARDS need this. -->
            <ng-container *ngIf="planV2ShowIgnored && planV2DismissedOnlyGroups().length > 0">
              <tr class="plan-v2-ignored-divider">
                <td colspan="10">Pages with dismissed cards — the page is still in review, its cards are not</td>
              </tr>
              <tr
                *ngFor="let group of planV2DismissedOnlyGroups(); trackBy: trackPlanV2DismissedGroup"
                class="plan-v2-row plan-v2-row--ignored"
              >
                <td>
                  <span class="badge badge--muted">{{ group.priorityScore | number:'1.0-0' }}</span>
                </td>
                <td class="muted">—</td>
                <td class="col-plan-v2-change muted">—</td>
                <td class="plan-v2-url-cell" [title]="group.url">{{ group.url }}</td>
                <td colspan="5" class="muted">
                  {{ group.items.length === 1 ? '1 card dismissed' : group.items.length + ' cards dismissed' }}:
                  {{ planV2DismissedCardTitles(group) }}
                </td>
                <td class="plan-v2-row-actions">
                  <button
                    type="button"
                    class="btn btn--sm"
                    (click)="planV2RestoreDismissedUrl(group, $event)"
                    [disabled]="workItemReopeningUrlId === group.urlId"
                    title="Return this page's dismissed cards to the Issues queue"
                  >
                    {{ workItemReopeningUrlId === group.urlId ? 'Restoring…' : 'Restore cards' }}
                  </button>
                </td>
              </tr>
            </ng-container>
            <ng-container *ngIf="planV2ShowIgnored && planV2IgnoredRows().length > 0">
              <tr class="plan-v2-ignored-divider">
                <td colspan="10">Ignored URLs — hidden until restored</td>
              </tr>
              <tr *ngFor="let row of planV2IgnoredRows(); trackBy: trackPlanV2Row" class="plan-v2-row plan-v2-row--ignored">
                <td>
                  <span class="badge badge--muted">{{ row.opportunityScore | number:'1.0-0' }}</span>
                </td>
                <td>
                  <span class="badge badge--muted">{{ planV2DisplayTier(row) | number:'1.0-0' }}</span>
                </td>
                <td class="col-plan-v2-change muted">—</td>
                <td class="plan-v2-url-cell" [title]="row.url">{{ row.url }}</td>
                <td colspan="5" class="muted">Ignored — expand findings are paused for this URL</td>
                <td class="plan-v2-row-actions">
                  <button type="button" class="btn btn--sm" (click)="planV2RestoreIgnoredUrl(row, $event)">
                    Restore
                  </button>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>

      <nav class="plan-v2-pagination" *ngIf="planV2Meta && planV2Meta.totalPages > 1" aria-label="Plan v2 pagination">
        <button type="button" class="btn btn--sm" [disabled]="planV2Page <= 1" (click)="planV2GoToPage(planV2Page - 1)">Previous</button>
        <span class="muted">Page {{ planV2Meta.page }} of {{ planV2Meta.totalPages }}</span>
        <button
          type="button"
          class="btn btn--sm"
          [disabled]="planV2Page >= planV2Meta.totalPages"
          (click)="planV2GoToPage(planV2Page + 1)"
        >Next</button>
      </nav>
    </div>
  </ng-container>

  <!-- Issues review drawer: must stay outside `pages` *ngIf or it is not in the DOM on Issues tab. -->
  <div class="drawer" *ngIf="planV2DrawerRow as drawerRowGlobal">
    <button
      type="button"
      class="drawer__scrim"
      aria-label="Close review drawer"
      (click)="closePlanV2Drawer()"
    ></button>
    <aside
      class="drawer__panel"
      role="dialog"
      aria-modal="true"
      aria-labelledby="plan-v2-drawer-title-global"
      (click)="$event.stopPropagation()"
    >
      <header class="drawer__header">
        <div class="drawer__header-text">
          <h3 id="plan-v2-drawer-title-global" class="drawer__title">Review URL</h3>
          <a
            class="drawer__url"
            [href]="drawerRowGlobal.url"
            target="_blank"
            rel="noopener noreferrer"
            [title]="drawerRowGlobal.url"
            >{{ drawerRowGlobal.url }}</a
          >
          <p class="drawer__meta muted">
            <strong>{{ drawerRowGlobal.recommendedAction.label }}</strong>
            · Priority {{ drawerRowGlobal.priorityScore | number:'1.0-0' }}
            <span class="plan-v2-drawer-period" *ngIf="planV2Period as period" [title]="planV2PeriodHint()">
              · {{ period.label }}
            </span>
          </p>
        </div>
        <div class="drawer__actions">
          <button type="button" class="btn btn--sm" (click)="planV2OpenUrlDetail(drawerRowGlobal, $event)">
            URL detail
          </button>
          <button
            type="button"
            class="btn btn--sm btn--quiet"
            (click)="planV2IgnoreUrl(drawerRowGlobal, $event)"
            [disabled]="planV2IgnoringUrlId === drawerRowGlobal.urlId"
            title="Hide this URL from this period’s brief (restore via Show hidden or Regenerate queue)"
          >
            Ignore URL
          </button>
          <button type="button" class="btn btn--sm" (click)="closePlanV2Drawer()">Close</button>
        </div>
      </header>
      <div class="drawer__body">
        <app-url-detail
          [embedUrl]="drawerRowGlobal.url"
          embedPreset="planV2"
          [embedPlanV2InDrawer]="true"
          [embedActionsOnly]="planV2ActionsOnly"
          [embedPlanV2Domain]="selectedDomain"
          [embedPlanV2Row]="drawerRowGlobal"
          [embedPlanV2QueueRank]="planV2QueueRankFor(drawerRowGlobal)"
          (intentOverrideCompleted)="onPlanV2IntentOverrideCompleted()"
        ></app-url-detail>
      </div>
    </aside>
  </div>

  <ng-container *ngIf="inventorySection === 'workItems' && isActionPlanV2Enabled()">
    <div class="inventory-container inventory-work-items-panel">
      <header class="inventory-plan-header">
        <h2 class="inventory-plan-title">Work items</h2>
        <p class="inventory-plan-lead">
          What you accepted <strong>this period</strong>, grouped by page — open a URL in your CMS and work
          through its tasks in one pass. New items appear here as you triage the living brief.
        </p>
        <p class="inventory-plan-lead muted" *ngIf="planV2PreviousWorkItems().length">
          <strong>{{ planV2PreviousWorkItems().length }}</strong>
          item{{ planV2PreviousWorkItems().length === 1 ? '' : 's' }} accepted before this period began sit in
          <button type="button" class="btn btn--bare" (click)="openPreviousTab()">Previous</button>.
        </p>
      </header>

      <div class="action-plan-controls">
        <button
          type="button"
          class="btn btn--sm"
          (click)="loadPlanV2IssueDispositions()"
          [disabled]="planV2IssuesLoading || !selectedDomain"
        >
          {{ planV2IssuesLoading ? 'Refreshing…' : 'Refresh' }}
        </button>
        <button
          type="button"
          class="btn btn--sm"
          (click)="exportWorkItemsPdf()"
          [disabled]="workItemsExporting || planV2WorkItems().length === 0"
        >
          {{ workItemsExporting ? 'Exporting…' : 'Export PDF' }}
        </button>
        <button type="button" class="btn btn--bare" (click)="setInventorySection('planV2')">Back to Issues</button>
      </div>

      <section
        class="plan-v2-summary work-items-recap"
        *ngIf="planV2WorkItems().length > 0 && planV2WorkItemsRecap().length"
        aria-label="Work items recap"
      >
        <div class="plan-v2-summary-head">
          <h3 class="plan-v2-summary-title">Recap</h3>
          <!-- Site-wide tasks are counted apart from the page count, because
               they are not on a page: one of them is a template fix. Rolling
               them into "across N pages" was how they hid. -->
          <span class="plan-v2-summary-queue muted">
            <strong>{{ planV2WorkItems().length }}</strong>
            task{{ planV2WorkItems().length === 1 ? '' : 's' }}
            <ng-container *ngIf="planV2SiteWideWorkItemCount() as siteWide">
              — <strong>{{ siteWide }}</strong> site-wide, the rest
            </ng-container>
            across
            <strong>{{ planV2WorkItemsByUrl().length }}</strong>
            page{{ planV2WorkItemsByUrl().length === 1 ? '' : 's' }}
          </span>
        </div>
        <div class="plan-v2-summary-stats">
          <span class="plan-v2-stat" *ngFor="let line of planV2WorkItemsRecap()">
            <strong>{{ line.count }}</strong> {{ line.text }}
          </span>
        </div>
      </section>

      <p class="plan-empty-message" *ngIf="!planV2IssuesLoading && planV2WorkItems().length === 0">
        Nothing accepted this period yet. On the Issues tab, expand a URL and use
        <strong>Add to work items</strong> on a card.
      </p>

      <!-- Site-wide first, then a group per page. A template defect stores the
           page it was sent from, so grouping on that alone filed one fix for the
           whole site under whichever URL the operator happened to be reading. -->
      <div class="work-items-list" *ngIf="planV2WorkItems().length > 0">
        <section
          class="work-items-url-group"
          [class.work-items-url-group--site-wide]="group.kind === 'site_wide'"
          *ngFor="let group of planV2WorkItemGroups(); trackBy: trackWorkItemGroup"
        >
          <header class="work-items-url-group-head">
            <div class="work-items-url-group-title">
              <h3 class="work-items-url-group-url">
                <a
                  *ngIf="group.kind === 'url'"
                  [href]="group.url"
                  target="_blank"
                  rel="noopener noreferrer"
                  >{{ group.url }}</a
                >
                <span *ngIf="group.kind === 'site_wide'">{{ group.label }}</span>
              </h3>
              <span class="work-items-url-group-meta muted">
                {{ group.items.length }} task{{ group.items.length === 1 ? '' : 's' }}
              </span>
            </div>
            <div class="work-items-url-group-actions">
              <span class="badge" *ngIf="group.priorityScore > 0">{{ group.priorityScore | number:'1.0-0' }}</span>
              <ng-container *ngIf="group.kind === 'url'">
                <button type="button" class="btn btn--sm" (click)="openUrlDetailForUrl(group.url, $event)">
                  URL detail
                </button>
                <!-- The way back in for ONE page. "Regenerate queue" is the
                     whole domain; this is the page in front of you. -->
                <button
                  type="button"
                  class="btn btn--sm"
                  (click)="planV2ReopenUrl(group, $event)"
                  [disabled]="workItemReopeningUrlId === group.urlId"
                  title="Return this page's decisions to the Issues queue so it comes back into review"
                >
                  {{ workItemReopeningUrlId === group.urlId ? 'Re-opening…' : 'Re-open page' }}
                </button>
              </ng-container>
            </div>
          </header>
          <p class="work-items-url-group-note muted" *ngIf="group.kind === 'site_wide'">
            {{ planV2SiteWideGroupNote() }}
          </p>
          <article
            class="work-item card card--pad work-item--nested"
            *ngFor="let item of group.items; trackBy: trackWorkItem"
            [class.work-item--returning]="workItemReturningKey === item.issueKey"
          >
            <app-plan-v2-work-item-body [item]="item" />
            <div class="card card--pad work-item-actions">
              <button
                type="button"
                class="btn btn--sm"
                (click)="returnWorkItemToIssues(item, $event)"
                [disabled]="workItemReturningKey === item.issueKey"
              >
                Back to issues
              </button>
            </div>
          </article>
        </section>
      </div>

      <section class="work-items-previous" *ngIf="planV2PreviousWorkItems().length > 0">
        <header class="work-items-previous-head">
          <h3 class="work-items-previous-title">Previous period</h3>
          <p class="work-items-previous-lead muted">
            What we committed to last period, archived when the newest crawl was captured. Read-only —
            use <strong>Carry forward</strong> if the advice still stands.
          </p>
        </header>
        <article
          class="work-item card card--pad work-item--previous"
          *ngFor="let item of planV2PreviousWorkItems(); trackBy: trackWorkItem"
        >
          <app-plan-v2-work-item-body [item]="item" />
          <div class="card card--pad work-item-actions">
            <span class="muted" *ngIf="planV2CarriedForward(item)">Carried forward</span>
            <button
              type="button"
              class="btn btn--sm"
              *ngIf="!planV2CarriedForward(item)"
              (click)="carryWorkItemForward(item, $event)"
              [disabled]="workItemCarryingKey === item.issueKey"
            >
              {{ workItemCarryingKey === item.issueKey ? 'Adding…' : 'Carry forward' }}
            </button>
          </div>
        </article>
      </section>
    </div>
  </ng-container>

  <!-- Previous: last period's commitments, compare only (docs/LIVING_BRIEF_PLAN.md LB2). -->
  <ng-container *ngIf="inventorySection === 'previous' && isActionPlanV2Enabled()">
    <div class="inventory-container inventory-previous-panel">
      <header class="inventory-plan-header">
        <h2 class="inventory-plan-title">Previous</h2>
        <p class="inventory-plan-lead">
          What you said last period, kept so you can check it against what moved. Nothing here is part of
          this period’s <button type="button" class="btn btn--bare" (click)="setInventorySection('planV2')">living brief</button>.
        </p>
      </header>

      <div class="action-plan-controls">
        <button
          type="button"
          class="btn btn--sm"
          (click)="loadPlanV2IssueDispositions()"
          [disabled]="planV2IssuesLoading || !selectedDomain"
        >
          {{ planV2IssuesLoading ? 'Refreshing…' : 'Refresh' }}
        </button>
        <button
          type="button"
          class="btn btn--sm"
          (click)="planV2ClearPreviousPeriod()"
          [disabled]="planV2ClearingPrevious || planV2PreviousItemCount() === 0 || !selectedDomain"
          title="Delete last period’s saved items. This period’s brief and work items are not touched."
        >
          {{ planV2ClearingPrevious ? 'Clearing…' : 'Clear history' }}
        </button>
        <button type="button" class="btn btn--bare" (click)="setInventorySection('planV2')">Back to Issues</button>
      </div>

      <p class="plan-empty-message" *ngIf="!planV2IssuesLoading && !planV2HasPreviousPeriod()">
        No previous period yet. This domain has one comparable crawl, so everything in the living brief and
        Work items belongs to the current brief.
      </p>

      <ng-container *ngIf="planV2HasPreviousPeriod()">
        <p class="previous-period-note muted">
          Only your decisions are kept: the previous brief’s full queue is not archived, so what you see is
          what you accepted or dismissed before the latest crawl was captured.
        </p>

        <p
          class="plan-empty-message"
          *ngIf="!planV2IssuesLoading && planV2PreviousItemCount() === 0"
        >
          Nothing was accepted or dismissed before this period began.
        </p>

        <section class="previous-period-section" *ngIf="planV2PreviousWorkItems().length">
          <h3 class="previous-period-title">
            Accepted last period
            <span class="muted">
              — {{ planV2PreviousWorkItems().length }}
              task{{ planV2PreviousWorkItems().length === 1 ? '' : 's' }} across
              {{ planV2PreviousWorkItemsByUrl().length }}
              page{{ planV2PreviousWorkItemsByUrl().length === 1 ? '' : 's' }}
            </span>
          </h3>
          <div class="work-items-list">
            <section
              class="work-items-url-group work-items-url-group--previous"
              [class.work-items-url-group--site-wide]="group.kind === 'site_wide'"
              *ngFor="let group of planV2PreviousWorkItemGroups(); trackBy: trackWorkItemGroup"
            >
              <header class="work-items-url-group-head">
                <div class="work-items-url-group-title">
                  <h4 class="work-items-url-group-url">
                    <a
                      *ngIf="group.kind === 'url'"
                      [href]="group.url"
                      target="_blank"
                      rel="noopener noreferrer"
                      >{{ group.url }}</a
                    >
                    <span *ngIf="group.kind === 'site_wide'">{{ group.label }}</span>
                  </h4>
                  <span class="work-items-url-group-meta muted">
                    {{ group.items.length }} task{{ group.items.length === 1 ? '' : 's' }}
                  </span>
                </div>
                <div class="work-items-url-group-actions">
                  <button
                    type="button"
                    class="btn btn--sm"
                    *ngIf="group.kind === 'url'"
                    (click)="openUrlDetailForUrl(group.url, $event)"
                  >
                    URL detail
                  </button>
                </div>
              </header>
              <article
                class="work-item work-item--nested card card--pad work-item--previous"
                *ngFor="let item of group.items; trackBy: trackWorkItem"
              >
                <app-plan-v2-work-item-body [item]="item" />
              </article>
            </section>
          </div>
        </section>

        <section class="previous-period-section" *ngIf="planV2PreviousDismissedItems().length">
          <h3 class="previous-period-title">
            Dismissed or ignored last period
            <span class="muted">— {{ planV2PreviousDismissedItems().length }}</span>
          </h3>
          <ul class="previous-dismissed-list">
            <li class="previous-dismissed-row" *ngFor="let item of planV2PreviousDismissedItems(); trackBy: trackWorkItem">
              <span class="previous-dismissed-title">{{ item.cardTitle }}</span>
              <a class="previous-dismissed-url" [href]="item.url" target="_blank" rel="noopener noreferrer" [title]="item.url">
                {{ item.url }}
              </a>
            </li>
          </ul>
        </section>
      </ng-container>
    </div>
  </ng-container>

  <!-- Every pair of pages that compete for the same searches, with the Cannibalization card's
       verdict (rules: shared/src/review/cannibalization-card.ts, competingPairList). Read-only. -->
  <ng-container *ngIf="inventorySection === 'competing'">
    <div class="inventory-container">
      <header class="inventory-plan-header">
        <h2 class="inventory-plan-title">Competing pages</h2>
        <p class="inventory-plan-lead">
          Pairs of this site’s pages that Google shows for the same searches, and what the review surface
          advises for each: a merge when one page wins the searches they share and the other adds nothing of its
          own, otherwise checked, with the reason no change is advised.
        </p>
      </header>
      <app-inventory-competing-pages [domain]="selectedDomain" />
    </div>
  </ng-container>

  <ng-container *ngIf="inventorySection === 'pages'">
<!-- Loading State (single-column mode only; compare mode uses per-panel spinners) -->
<div class="inventory-container" *ngIf="loading && !isCompareTopicMode">
  <div class="loading-state">
    <div class="loading-spinner"></div>
    <p>Loading content inventory…</p>
  </div>
</div>

<!-- Error State (single-column mode only) -->
<div class="inventory-container" *ngIf="error && !loading && !isCompareTopicMode">
  <div class="error-state">
    <div class="error-icon">⚠️</div>
    <h2>Something went wrong</h2>
    <p>{{ error }}</p>
    <button class="btn btn--accent" (click)="loadInventory()">Try Again</button>
  </div>
</div>

<!-- Empty State (no pages analyzed yet) -->
<div class="inventory-container" *ngIf="isEmpty">
  <div class="empty-state">
    <div class="empty-icon">📋</div>
    <h1>No pages analyzed yet<span *ngIf="selectedDomain"> on {{ selectedDomain }}</span></h1>
    <p class="empty-subtitle">Run a page comparison to start building your content inventory for this domain.</p>
    <a routerLink="/page-comparison" class="btn btn--accent">Compare Two Pages</a>
  </div>
</div>

<!-- Content -->
<div
  class="inventory-container"
  [class.inventory-container-compare]="isCompareTopicMode"
  [class.inventory-container--fab-pad]="!isCompareTopicMode && bulkClusterSelectionCount > 0"
  *ngIf="!isEmpty && (isCompareTopicMode || (!loading && !error))"
>
  <header class="inventory-header">
    <div class="header-text">
      <h1>Content Inventory</h1>
      <p class="header-subtitle" *ngIf="!isCompareTopicMode">
        {{ pagination.total }} analyzed page{{ pagination.total === 1 ? '' : 's' }}
        <span *ngIf="selectedDomain"> on {{ selectedDomain }}</span>
      </p>
      <p class="header-subtitle" *ngIf="isCompareTopicMode">
        Same topic, search, and sort for both domains; each column has its own pagination.
        On narrower screens, panels stack so each table can use the full width. Scroll inside a panel if columns do not fit.
      </p>
    </div>
  </header>

  <!-- Search & Controls: primary filters + expandable advanced filters (solo Pages). -->
  <div class="controls-bar">
    <div class="controls-row controls-row-primary">
    <div class="tracking-filter" *ngIf="selectedDomain">
      <span class="tracking-filter-label">Tracking</span>
      <div class="tracking-filter-segments" role="tablist" aria-label="Tracking filter">
        <button type="button" class="tracking-filter-segment" [class.tracking-filter-segment--active]="trackingFilter === 'tracked'" (click)="updateTrackingFilter('tracked')">Tracked</button>
        <button type="button" class="tracking-filter-segment" [class.tracking-filter-segment--active]="trackingFilter === 'excluded'" (click)="updateTrackingFilter('excluded')">Excluded</button>
        <button type="button" class="tracking-filter-segment" [class.tracking-filter-segment--active]="trackingFilter === 'all'" (click)="updateTrackingFilter('all')">All</button>
      </div>
    </div>

    <div class="tracking-filter health-filter" *ngIf="selectedDomain">
      <span class="tracking-filter-label">Health</span>
      <div class="tracking-filter-segments" role="group" aria-label="Health filter">
        <button
          type="button"
          class="tracking-filter-segment"
          *ngFor="let band of healthFilterBandOptions"
          [class.tracking-filter-segment--active]="isHealthBandFilterSelected(band)"
          (click)="toggleHealthBandFilter(band)"
        >
          {{ healthFilterLabel(band) }}
        </button>
      </div>
    </div>

    <div class="path-prefix-filter" *ngIf="!isCompareTopicMode && selectedDomain">
      <span class="path-prefix-label">Path</span>
      <p class="path-prefix-hint">Optional. Subfolders: listed only if some URL uses /segment/…. <strong>Homepage</strong> = path / only. <strong>Top-level</strong> = one path segment (e.g. /browserstack), not /a/b. Topic filter still applies. OR across selections.</p>
      <div class="path-prefix-chips">
        <button
          type="button"
          class="btn btn--sm"
          *ngFor="let p of primaryPathChipOptions()"
          [class.btn--accent]="isPathPrefixSelected(p, 'primary')"
          (click)="togglePathPrefix(p, 'primary')"
        >
          {{ pathPrefixChipLabel(p) }}
        </button>
      </div>
      <span class="path-prefix-status" *ngIf="loadingPathPrefixes">Loading paths…</span>
      <span class="path-prefix-status path-prefix-error" *ngIf="!loadingPathPrefixes && pathPrefixError">{{ pathPrefixError }}</span>
    </div>
    </div>

    <div class="controls-row controls-row-search">
    <div class="search-box search-box--full">
      <span class="search-icon">🔍</span>
      <input
        type="text"
        [(ngModel)]="searchQuery"
        (ngModelChange)="onSearchChange()"
        placeholder="Search by URL…"
        class="search-entry"
      />
    </div>
    <div class="columns-picker" data-column-picker-root>
      <button
        type="button"
        class="btn btn--sm columns-picker-trigger"
        [attr.aria-expanded]="columnPickerOpen"
        (click)="toggleColumnPicker($event)"
      >
        Columns
      </button>
      <div class="columns-picker-menu" *ngIf="columnPickerOpen" (click)="$event.stopPropagation()">
        <div class="columns-picker-title">Show columns</div>
        <label class="columns-picker-item" *ngFor="let option of columnOptions">
          <input
            type="checkbox"
            [checked]="isColumnVisible(option.key)"
            [disabled]="!isColumnOptionAvailable(option)"
            (change)="toggleColumnVisibility(option.key, $event)"
          />
          <span>{{ option.label }}</span>
        </label>
        <p class="columns-picker-hint" *ngIf="!hasTopicScope">
          Topic columns activate when a topic filter is selected.
        </p>
        <button type="button" class="columns-picker-close" (click)="closeColumnPicker($event)">Done</button>
      </div>
    </div>
    <button
      type="button"
      class="btn btn--sm pages-filters-toggle"
      *ngIf="usePagesFilterCollapse()"
      [attr.aria-expanded]="pagesFiltersExpanded"
      (click)="togglePagesFiltersExpanded()"
    >
      Filters
    </button>
    <span class="cluster-filter-draft-hint" *ngIf="usePagesFilterCollapse() && clusterFilterApplyVisible">
      Cluster filter not applied — open Filters to apply.
    </span>
    </div>

    <div class="controls-row controls-row-expanded" *ngIf="!usePagesFilterCollapse() || pagesFiltersExpanded">
    <div class="topic-filter" [class.topic-filter--full-row]="isCompareTopicMode">
      <label for="inventory-topic-filter" class="topic-filter-label">Topic</label>
      <label class="topic-subtopic-toggle">
        <input
          type="checkbox"
          [(ngModel)]="includeChildTopics"
          (ngModelChange)="onIncludeChildTopicsChange()"
          [disabled]="loadingTopics || !selectedDomain"
        />
        <span>Include subtopics</span>
      </label>
      <div class="topic-typeahead">
        <input
        id="inventory-topic-filter"
        class="input topic-filter-input"
        type="text"
        [ngModel]="topicSearchQuery"
        (ngModelChange)="topicSearchQuery = $event; onTopicInputChange()"
        (focus)="onTopicInputFocus()"
        (blur)="onTopicInputBlur()"
        (keydown.enter)="applyTopicFromInput(); $event.preventDefault()"
        placeholder="All topics"
        [disabled]="loadingTopics || !selectedDomain"
        autocomplete="off"
      />
      <button
        type="button"
        class="btn btn--sm btn--quiet topic-clear"
        *ngIf="selectedTopicSlug || topicSearchQuery.trim()"
        (mousedown)="clearTopicFilter()"
        [disabled]="loadingTopics || !selectedDomain"
      >
        Clear
      </button>

      <div class="topic-suggestions" *ngIf="showTopicSuggestions && !loadingTopics && visibleTopicSuggestions.length > 0">
        <button
          type="button"
          class="topic-suggestion all-topics"
          (mousedown)="clearTopicFilter()"
        >
          <span class="topic-suggestion-label">All topics</span>
        </button>
        <div
          class="topic-suggestion-shell"
          *ngFor="let topic of visibleTopicSuggestions"
          (mouseenter)="onTopicSuggestionRowEnter(topic)"
          (mouseleave)="onTopicSuggestionRowLeave()"
        >
          <button type="button" class="topic-suggestion" (mousedown)="selectTopic(topic)">
            <span class="topic-suggestion-main">
              <span class="topic-suggestion-label">{{ topic.label }}</span>
              <span class="topic-suggestion-parent" *ngIf="topic.topicType === 'child'">in {{ topic.parentLabel }}</span>
              <span class="topic-suggestion-alias" *ngIf="topic.aliasLabels && topic.aliasLabels.length > 0">
                also {{ topic.aliasLabels.join(', ') }}
              </span>
            </span>
            <span class="topic-suggestion-tags">
              <span class="badge topic-kind-tag" [ngClass]="topicKindTagClass(topic)">
                {{ topic.topicType === 'child' ? 'Child' : 'Parent' }}
              </span>
              <span class="badge topic-authority-tag" [ngClass]="topicAuthorityTagClass(topic.authorityScore)">
                {{ formatAuthorityScore(topic.authorityScore) }}
              </span>
            </span>
          </button>
          <div class="topic-suggestion-competitors" *ngIf="topicSuggestionCompetitorEntry(topic.slug) as comp">
            <span class="topic-suggestion-comp-label">Competitors</span>
            <ng-container [ngSwitch]="comp.status">
              <span *ngSwitchCase="'loading'" class="topic-suggestion-comp-loading">Loading scores…</span>
              <span *ngSwitchCase="'error'" class="topic-suggestion-comp-error">{{ comp.error }}</span>
              <ng-container *ngSwitchCase="'ready'">
                <p *ngIf="!comp.rows?.length" class="topic-suggestion-comp-empty">
                  You have no marked competitors yet. Open the header <strong>Competitors</strong> menu to add domains; we use the same Domain Topics authority score as for your active domain (when that competitor has URLs and aggregates in this workspace).
                </p>
                <div class="topic-suggestion-comp-chips" *ngIf="comp.rows?.length">
                  <ng-container *ngFor="let row of comp.rows">
                    <span
                      *ngIf="row.kind === 'ready'"
                      class="btn btn--sm topic-suggestion-comp-chip--ready"
                      role="button"
                      tabindex="0"
                      (mousedown)="compareWithTopicFromDropdown(row.domain, topic, $event)"
                      [class.topic-suggestion-comp-chip--disabled]="isSavingCompareFromTopicPill"
                    >
                      <span class="topic-suggestion-comp-chip-domain">{{ row.domain }}</span>
                      <span
                        class="badge topic-suggestion-comp-chip-score topic-authority-tag"
                        [ngClass]="topicAuthorityTagClass(row.authorityScore)"
                      >
                        {{ formatAuthorityScore(row.authorityScore) }}
                      </span>
                    </span>
                    <span
                      *ngIf="row.kind === 'unavailable'"
                      class="badge topic-suggestion-comp-chip--muted"
                      [title]="row.message"
                    >
                      <span class="topic-suggestion-comp-chip-domain">{{ row.domain }}</span>
                      <span class="topic-suggestion-comp-chip-dash">—</span>
                    </span>
                  </ng-container>
                </div>
                <p class="topic-suggestion-comp-footnote">
                  Scores load after ~120ms hover to limit API traffic. Muted “—” means no score: hover or focus the chip for the full reason (workspace URL requirement, missing aggregates, or topic not on that domain).
                </p>
              </ng-container>
            </ng-container>
          </div>
        </div>
        <p class="topic-suggestions-hover-hint" *ngIf="visibleTopicSuggestions.length">
          Hover a topic row to load each <strong>marked competitor’s</strong> authority on that topic (same 0–100 score as the picker). Click a green chip to compare side-by-side.
        </p>
      </div>
      </div>
      <span class="topic-filter-status" *ngIf="loadingTopics">Loading topics...</span>
      <span class="topic-filter-status topic-filter-error" *ngIf="!loadingTopics && topicError">{{ topicError }}</span>

      <div
        class="topic-competitor-strip"
        *ngIf="showTopicCompetitorStrip"
        role="region"
        aria-label="Compare topic with marked competitors"
      >
        <div class="topic-competitor-strip-head">
          <span class="topic-competitor-strip-label">Compare · marked competitors</span>
          <span class="topic-competitor-strip-hint">Authority matches the topic list above. Click a domain to open side-by-side inventory.</span>
        </div>

        <p class="topic-competitor-strip-loading" *ngIf="competitorTopicPillsLoading">Loading competitor topic scores…</p>

        <p class="topic-competitor-strip-error topic-filter-error" *ngIf="!competitorTopicPillsLoading && competitorTopicPillsSettingsError">
          {{ competitorTopicPillsSettingsError }}
        </p>

        <p class="topic-competitor-strip-error topic-filter-error" *ngIf="!competitorTopicPillsLoading && compareTopicPillSaveError">
          {{ compareTopicPillSaveError }}
        </p>

        <div class="topic-competitor-strip-no-marked" *ngIf="!competitorTopicPillsLoading && competitorTopicPillsNoMarked">
          <p>
            You have no <strong>marked competitors</strong> yet. Use the header <strong>Competitors</strong> menu to add domains you want to compare.
            For each competitor that has URLs in this workspace and aggregated Domain Topics, we show the same topic authority score as in the picker above.
          </p>
          <p *ngIf="featureFlags.isEnabled('competitorFinder')">
            You can also run <a routerLink="/competitor-finder" class="topic-competitor-strip-link">Competitor Finder</a> to discover candidates, then mark them in the header.
          </p>
        </div>

        <div class="topic-competitor-pills" *ngIf="!competitorTopicPillsLoading && competitorTopicPills.length > 0">
          <ng-container *ngFor="let pill of competitorTopicPills">
            <button
              *ngIf="pill.kind === 'ready'"
              type="button"
              class="btn btn--sm topic-competitor-pill--ready"
              (click)="selectCompareDomainFromTopicPill(pill.domain)"
              [disabled]="isSavingCompareFromTopicPill"
            >
              <span class="topic-competitor-pill-domain">{{ pill.domain }}</span>
              <span
                class="badge topic-competitor-pill-score topic-authority-tag"
                [ngClass]="topicAuthorityTagClass(pill.authorityScore)"
              >
                {{ formatAuthorityScore(pill.authorityScore) }}
              </span>
            </button>
            <div *ngIf="pill.kind === 'unavailable'" class="topic-competitor-pill topic-competitor-pill--unavailable">
              <span class="topic-competitor-pill-domain">{{ pill.domain }}</span>
              <p class="topic-competitor-pill-reason">{{ pill.message }}</p>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="dev-traffic-actions" *ngIf="isDevView() && selectedDomain">
      <button
        type="button"
        class="btn btn--sm"
        (click)="runTrafficRefreshForActiveDomain()"
        [disabled]="trafficRefreshRunning"
      >
        {{ trafficRefreshRunning ? 'Refreshing traffic…' : 'Refresh est. traffic (dev)' }}
      </button>
      <button
        type="button"
        class="btn btn--sm"
        (click)="runRankedKeywordsRefreshForActiveDomain()"
        [disabled]="rankedKwDevRunning || !selectedDomain"
      >
        {{ rankedKwDevRunning ? 'Refreshing keywords…' : 'Refresh est. keywords (dev)' }}
      </button>
      <button
        type="button"
        class="btn btn--sm"
        (click)="runDemandLabelRefreshForActiveDomain()"
        [disabled]="demandLabelRefreshRunning || !selectedDomain"
      >
        {{ demandLabelRefreshRunning ? 'Refreshing demand…' : 'Refresh page demand (dev)' }}
      </button>
      <span class="dev-serp-refresh-group">
        <button
          type="button"
          class="btn btn--sm"
          (click)="runUrlSerpRefreshForActiveDomain()"
          [disabled]="urlSerpRefreshRunning || !selectedDomain"
        >
          {{ urlSerpRefreshRunning ? 'Refreshing SERP…' : 'Refresh URL SERP (dev)' }}
        </button>
        <label class="dev-serp-force-label" title="Re-fetch SERP and keyword difficulty from API (bypass TopicSerp + KeywordDifficultyCache). ~$0.002/SERP + ~$0.01/batch KD per chunk.">
          <input
            type="checkbox"
            [(ngModel)]="urlSerpForceRefresh"
            [disabled]="urlSerpRefreshRunning"
          />
          Force API
        </label>
      </span>
    </div>

    <div
      class="cannibal-rkw-progress url-serp-dev-progress"
      *ngIf="urlSerpRefreshRunning && urlSerpRefreshProgress"
      role="status"
      aria-live="polite"
    >
      <div class="cannibal-rkw-progress-bar-wrap">
        <div class="cannibal-rkw-progress-bar">
          <div class="cannibal-rkw-progress-fill" [style.width.%]="urlSerpRefreshProgress.percent"></div>
        </div>
      </div>
      <div class="cannibal-rkw-progress-meta">
        <span class="cannibal-rkw-progress-line">{{ urlSerpRefreshProgress.statusLine }}</span>
        <span class="cannibal-rkw-eta" *ngIf="urlSerpRefreshProgress.etaLabel">{{ urlSerpRefreshProgress.etaLabel }}</span>
      </div>
    </div>

    <div class="controls-row controls-row-clusters" *ngIf="!isCompareTopicMode && selectedDomain && planClusters.length > 0">
      <div class="cluster-filter-block" data-cluster-filter-root>
        <div class="cluster-filter-head">
          <div class="cluster-filter-title">
            <span class="cluster-filter-label">Cluster filter</span>
            <span class="cluster-filter-subtitle">Find pages…</span>
          </div>
        </div>

        <div class="cluster-filter-rules">
          <div class="cluster-filter-rule" *ngFor="let rule of clusterFilterRules; let i = index; trackBy: trackClusterFilterRule">
            <div class="cluster-rule-row">
              <div class="cluster-rule-join" *ngIf="i > 0">
                <label class="visually-hidden" [attr.for]="'cluster-rule-join-' + rule.uid">Combine with previous rule</label>
                <select
                  class="input cluster-rule-join-select"
                  [id]="'cluster-rule-join-' + rule.uid"
                  [(ngModel)]="rule.join"
                  (ngModelChange)="setClusterRuleJoin(rule, $event)"
                >
                  <option [ngValue]="'and'">AND</option>
                  <option [ngValue]="'or'">OR</option>
                </select>
              </div>

              <div class="cluster-rule-mode">
                <label class="visually-hidden" [attr.for]="'cluster-rule-mode-' + rule.uid">Cluster rule mode</label>
                <select
                  class="input cluster-rule-mode-select"
                  [id]="'cluster-rule-mode-' + rule.uid"
                  [(ngModel)]="rule.mode"
                  (ngModelChange)="setClusterRuleMode(rule, $event)"
                >
                  <option [ngValue]="'or'">IN</option>
                  <option [ngValue]="'not'">NOT IN</option>
                </select>
              </div>

              <div class="cluster-rule-dropdown-wrap">
                <button
                  type="button"
                  class="cluster-rule-trigger"
                  (click)="toggleClusterFilterDropdown(rule.uid, $event)"
                  [attr.aria-expanded]="clusterFilterOpenRuleUid === rule.uid"
                >
                  <span class="cluster-rule-trigger-text" *ngIf="rule.topicIds.length === 0">Select clusters…</span>
                  <span class="clusters-tags clusters-tags--trigger" *ngIf="rule.topicIds.length > 0">
                    <span class="badge badge--truncate cluster-tag" *ngFor="let id of rule.topicIds">{{ planClusterById(id)?.label || 'Cluster' }}</span>
                  </span>
                  <span class="cluster-rule-chevron" aria-hidden="true"></span>
                </button>

                <div
                  class="cluster-rule-menu"
                  *ngIf="clusterFilterOpenRuleUid === rule.uid"
                  data-cluster-filter-menu
                  (click)="$event.stopPropagation()"
                >
                  <div class="cluster-rule-menu-search">
                    <input
                      type="text"
                      [(ngModel)]="rule.searchQuery"
                      class="input cluster-rule-menu-input"
                      placeholder="Search clusters…"
                    />
                  </div>
                  <ul class="cluster-rule-menu-list" role="list" [attr.aria-multiselectable]="true">
                    <li class="cluster-rule-menu-item" *ngFor="let c of clustersForClusterFilterRule(rule)">
                      <label class="cluster-rule-menu-toggle">
                        <input
                          type="checkbox"
                          [checked]="isClusterSelectedInRule(rule, c.id)"
                          (change)="toggleClusterInRule(rule, c.id, $event)"
                        />
                        <span>{{ c.label }}</span>
                      </label>
                    </li>
                  </ul>
                </div>
              </div>

              <button
                type="button"
                class="btn cluster-rule-remove"
                *ngIf="clusterFilterRules.length > 1"
                (click)="removeClusterFilterRule(i)"
              >
                Remove
              </button>
            </div>
          </div>
        </div>

        <div class="cluster-filter-actions">
          <button type="button" class="btn btn--accent cluster-filter-apply" *ngIf="clusterFilterApplyVisible" (click)="applyClusterFilterDraft()">Apply</button>
          <button type="button" class="cluster-filter-add-rules" (click)="addClusterFilterRule()">+ Add rules</button>
        </div>
        <p class="cluster-filter-hint">Between rows: <span class="cluster-filter-hint-mono">AND</span> / <span class="cluster-filter-hint-mono">OR</span>. Within a row: <span class="cluster-filter-hint-mono">IN</span> or <span class="cluster-filter-hint-mono">NOT IN</span> the selected clusters. Use Apply to refresh the table.</p>
      </div>
    </div>
    </div>
  </div>

  <!-- No results for search (single column only) -->
  <div class="empty-search" *ngIf="showGlobalEmptySearch">
    <p *ngIf="searchQuery.trim() || selectedTopicSlug || appliedClusterFilterHasSelection">
      No pages match current filters<span *ngIf="searchQuery.trim()"> for "<strong>{{ searchQuery }}</strong>"</span><span *ngIf="selectedDomain"> on {{ selectedDomain }}</span>
    </p>
    <button type="button" class="btn" (click)="clearSearchTopicAndClusterFilters()">Clear filters</button>
  </div>

  <!-- Side-by-side compare (topic + Compare To) -->
  <div
    class="inventory-compare-mode"
    *ngIf="isCompareTopicMode"
    [class.inventory-compare-mode--fab-pad]="quickCompareBothSelected || bulkClusterSelectionCount > 0"
  >
    <div class="inventory-compare-grid">
    <section class="card card--pad inventory-compare-panel" aria-labelledby="inv-panel-active">
      <h2 id="inv-panel-active" class="card card--pad inventory-compare-title">{{ selectedDomain || 'Active domain' }}</h2>
      <p class="card card--pad inventory-compare-subtitle" *ngIf="!loading && !error">
        {{ pagination.total }} analyzed page{{ pagination.total === 1 ? '' : 's' }} matching filters
      </p>
      <p
        class="card card--pad inventory-compare-last"
        *ngIf="!loading && !error && pages.length > 0"
        [title]="'Newest analysis on this page: ' + lastAnalyzedTitle(pages)"
      >
        Last analyzed {{ lastAnalyzedSummary(pages) }}
      </p>

      <div class="inventory-panel-paths" *ngIf="selectedDomain">
        <span class="path-prefix-label">Path</span>
        <p class="path-prefix-hint path-prefix-hint--inline"><strong>Top-level</strong> = one segment (/browserstack). <strong>Homepage</strong> = / only. Topic filter still applies.</p>
        <div class="path-prefix-chips">
          <button
            type="button"
            class="btn btn--sm"
            *ngFor="let p of primaryPathChipOptions()"
            [class.btn--accent]="isPathPrefixSelected(p, 'primary')"
            (click)="togglePathPrefix(p, 'primary')"
          >
            {{ pathPrefixChipLabel(p) }}
          </button>
        </div>
        <span class="path-prefix-status" *ngIf="loadingPathPrefixes">Loading paths…</span>
        <span class="path-prefix-status path-prefix-error" *ngIf="!loadingPathPrefixes && pathPrefixError">{{ pathPrefixError }}</span>
      </div>

      <div class="panel-loading" *ngIf="loading">
        <div class="loading-spinner loading-spinner-sm"></div>
        <p>Loading…</p>
      </div>

      <div class="panel-error" *ngIf="!loading && error">
        <p>{{ error }}</p>
        <button type="button" class="btn" (click)="retryPrimaryInventory()">Try again</button>
      </div>

      <p class="panel-empty" *ngIf="panelHasNoRowsPrimary">
        No pages match current filters for this domain.
      </p>

      <div class="table-wrapper table-wrapper-compare" *ngIf="!loading && !error && pages.length > 0">
        <table class="table table--dense inventory-table inventory-table--compare">
          <thead>
            <tr>
              <th class="col-bulk-select" scope="col">
                <span class="visually-hidden">Select for cluster</span>
              </th>
              <th class="col-quick-compare-select" scope="col">
                <span class="visually-hidden">Select for quick compare</span>
              </th>
              <th class="col-url sortable table__sortable" (click)="toggleSort('url')">
                URL{{ sortIcon('url') }}
              </th>
              <th class="col-clusters" *ngIf="isColumnVisible('clusters')">Cluster</th>
              <th class="col-top-topics" *ngIf="isColumnVisible('topTopics')">Top topics</th>
              <th class="col-topic-class" *ngIf="hasTopicScope && isColumnVisible('topicClass')">Class</th>
              <th class="col-topic-relevance sortable table__sortable" *ngIf="hasTopicScope && isColumnVisible('topicRelevance')" (click)="toggleSort('topicRelevanceScore')">
                Relevance{{ sortIcon('topicRelevanceScore') }}
              </th>
              <th class="col-topic-weight sortable table__sortable" *ngIf="hasTopicScope && isColumnVisible('topicWeight')" (click)="toggleSort('topicWeight')">
                Weight{{ sortIcon('topicWeight') }}
              </th>
              <th class="col-keywords" *ngIf="isColumnVisible('keywords')">Keywords</th>
              <th class="col-traffic sortable table__sortable" *ngIf="isColumnVisible('estimatedOrganicTraffic')" (click)="toggleSort('estimatedOrganicTraffic')">
                Est. Traffic{{ sortIcon('estimatedOrganicTraffic') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngTemplateOutlet="inventoryRows; context: { $implicit: pages, compareSimple: true, comparePanel: 'primary', bulkSelectPrimary: true }"></ng-container>
          </tbody>
        </table>
      </div>

      <div class="pagination pagination-compact" *ngIf="!loading && !error && pagination.totalPages > 1">
        <button
          class="btn btn--sm"
          [disabled]="pagination.page <= 1"
          (click)="goToPage(pagination.page - 1)"
        >← Prev</button>
        <span class="page-info">
          Page {{ pagination.page }} of {{ pagination.totalPages }}
        </span>
        <button
          class="btn btn--sm"
          [disabled]="pagination.page >= pagination.totalPages"
          (click)="goToPage(pagination.page + 1)"
        >Next →</button>
      </div>
    </section>

    <section class="card card--pad inventory-compare-panel" aria-labelledby="inv-panel-compare">
      <h2 id="inv-panel-compare" class="card card--pad inventory-compare-title">{{ compareToDomain }}</h2>
      <p class="card card--pad inventory-compare-subtitle" *ngIf="!compareLoading && !compareError">
        {{ comparePagination.total }} analyzed page{{ comparePagination.total === 1 ? '' : 's' }} matching filters
      </p>
      <p
        class="card card--pad inventory-compare-last"
        *ngIf="!compareLoading && !compareError && comparePages.length > 0"
        [title]="'Newest analysis on this page: ' + lastAnalyzedTitle(comparePages)"
      >
        Last analyzed {{ lastAnalyzedSummary(comparePages) }}
      </p>

      <div class="inventory-panel-paths" *ngIf="compareToDomain">
        <span class="path-prefix-label">Path</span>
        <p class="path-prefix-hint path-prefix-hint--inline"><strong>Top-level</strong> vs <strong>Homepage</strong> — topic filter still applies.</p>
        <div class="path-prefix-chips">
          <button
            type="button"
            class="btn btn--sm"
            *ngFor="let p of comparePathChipOptions()"
            [class.btn--accent]="isPathPrefixSelected(p, 'compare')"
            (click)="togglePathPrefix(p, 'compare')"
          >
            {{ pathPrefixChipLabel(p) }}
          </button>
        </div>
        <span class="path-prefix-status" *ngIf="loadingComparePathPrefixes">Loading paths…</span>
        <span class="path-prefix-status path-prefix-error" *ngIf="!loadingComparePathPrefixes && comparePathPrefixError">{{ comparePathPrefixError }}</span>
      </div>

      <div class="panel-loading" *ngIf="compareLoading">
        <div class="loading-spinner loading-spinner-sm"></div>
        <p>Loading…</p>
      </div>

      <div class="panel-error" *ngIf="!compareLoading && compareError">
        <p>{{ compareError }}</p>
        <button type="button" class="btn" (click)="retryCompareInventory()">Try again</button>
      </div>

      <p class="panel-empty" *ngIf="panelHasNoRowsCompare">
        No pages match current filters for this domain.
      </p>

      <div class="table-wrapper table-wrapper-compare" *ngIf="!compareLoading && !compareError && comparePages.length > 0">
        <table class="table table--dense inventory-table inventory-table--compare">
          <thead>
            <tr>
              <th class="col-bulk-select col-bulk-select--spacer" aria-hidden="true"></th>
              <th class="col-quick-compare-select" scope="col">
                <span class="visually-hidden">Select for quick compare</span>
              </th>
              <th class="col-url sortable table__sortable" (click)="toggleSort('url')">
                URL{{ sortIcon('url') }}
              </th>
              <th class="col-clusters" *ngIf="isColumnVisible('clusters')">Cluster</th>
              <th class="col-top-topics" *ngIf="isColumnVisible('topTopics')">Top topics</th>
              <th class="col-topic-class" *ngIf="hasTopicScope && isColumnVisible('topicClass')">Class</th>
              <th class="col-topic-relevance sortable table__sortable" *ngIf="hasTopicScope && isColumnVisible('topicRelevance')" (click)="toggleSort('topicRelevanceScore')">
                Relevance{{ sortIcon('topicRelevanceScore') }}
              </th>
              <th class="col-topic-weight sortable table__sortable" *ngIf="hasTopicScope && isColumnVisible('topicWeight')" (click)="toggleSort('topicWeight')">
                Weight{{ sortIcon('topicWeight') }}
              </th>
              <th class="col-keywords" *ngIf="isColumnVisible('keywords')">Keywords</th>
              <th class="col-traffic sortable table__sortable" *ngIf="isColumnVisible('estimatedOrganicTraffic')" (click)="toggleSort('estimatedOrganicTraffic')">
                Est. Traffic{{ sortIcon('estimatedOrganicTraffic') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngTemplateOutlet="inventoryRows; context: { $implicit: comparePages, compareSimple: true, comparePanel: 'compare' }"></ng-container>
          </tbody>
        </table>
      </div>

      <div class="pagination pagination-compact" *ngIf="!compareLoading && !compareError && comparePagination.totalPages > 1">
        <button
          class="btn btn--sm"
          [disabled]="comparePagination.page <= 1"
          (click)="goToComparePage(comparePagination.page - 1)"
        >← Prev</button>
        <span class="page-info">
          Page {{ comparePagination.page }} of {{ comparePagination.totalPages }}
        </span>
        <button
          class="btn btn--sm"
          [disabled]="comparePagination.page >= comparePagination.totalPages"
          (click)="goToComparePage(comparePagination.page + 1)"
        >Next →</button>
      </div>
    </section>
    </div>

    <div
      class="inventory-compare-floating-actions"
      *ngIf="quickCompareBothSelected || bulkClusterSelectionCount > 0"
    >
      <div class="inventory-quick-compare-actions" *ngIf="quickCompareBothSelected" aria-label="Quick compare">
        <button type="button" class="btn btn--accent" (click)="onQuickCompareCtaClick()">
          Quick compare
        </button>
        <button
          type="button"
          class="btn inventory-quick-compare-clear"
          (click)="clearQuickCompareSelection()"
        >
          Clear
        </button>
      </div>
      <div class="inventory-bulk-cluster-actions" *ngIf="bulkClusterSelectionCount > 0" aria-label="Add pages to cluster">
        <span class="inventory-bulk-cluster-summary">{{ bulkClusterSelectionCount }} page(s) selected</span>
        <label class="inventory-bulk-cluster-label" for="bulk-cluster-select-compare">Add to cluster</label>
        <select
          id="bulk-cluster-select-compare"
          class="input inventory-bulk-cluster-select"
          [(ngModel)]="bulkTargetClusterId"
        >
          <option [ngValue]="null">Choose a cluster…</option>
          <option *ngFor="let c of planClusters" [ngValue]="c.id">{{ c.label }}</option>
        </select>
        <button
          type="button"
          class="btn btn--accent"
          (click)="confirmBulkAddToCluster()"
          [disabled]="!bulkTargetClusterId || isBulkSaving"
        >
          {{ isBulkSaving ? 'Adding…' : 'Add' }}
        </button>
        <label class="inventory-bulk-cluster-label" for="bulk-cluster-remove-select-compare">Remove from cluster</label>
        <select
          id="bulk-cluster-remove-select-compare"
          class="input inventory-bulk-cluster-select"
          [(ngModel)]="bulkRemoveClusterId"
        >
          <option [ngValue]="null">Choose a cluster…</option>
          <option *ngFor="let c of planClusters" [ngValue]="c.id">{{ c.label }}</option>
        </select>
        <button
          type="button"
          class="btn"
          (click)="confirmBulkRemoveFromCluster()"
          [disabled]="!bulkRemoveClusterId || isBulkRemoving"
        >
          {{ isBulkRemoving ? 'Removing…' : 'Remove' }}
        </button>
        <button type="button" class="btn" (click)="clearBulkClusterSelection()">Clear selection</button>
        <button type="button" class="btn" (click)="markBulkSelectionIncluded()" [disabled]="isUpdatingInclusion">
          {{ isUpdatingInclusion ? 'Saving…' : 'Mark included' }}
        </button>
        <button type="button" class="btn" (click)="markBulkSelectionExcluded()" [disabled]="isUpdatingInclusion">
          {{ isUpdatingInclusion ? 'Saving…' : 'Mark excluded' }}
        </button>
        <p class="inventory-bulk-cluster-hint" *ngIf="planClusters.length === 0">
          No clusters yet —
          <button type="button" class="btn btn--bare" (click)="openPlanTabFromBulkHint()">Open Plan</button>
          to add a topic.
        </p>
      </div>
    </div>
  </div>

  <!-- Single-column table -->
  <div class="table-wrapper table-wrapper--pages-sticky" *ngIf="!isCompareTopicMode && pages.length > 0">
    <table class="table table--sticky-head inventory-table inventory-table--pages">
      <thead>
        <tr>
          <th class="col-bulk-select" scope="col">
            <span class="visually-hidden">Select for cluster</span>
          </th>
          <th class="col-url sortable table__sortable" (click)="toggleSort('url')">
            URL{{ sortIcon('url') }}
          </th>
          <th class="col-score sortable table__sortable" *ngIf="isColumnVisible('score')" (click)="toggleSort('onpageScore')">
            Score{{ sortIcon('onpageScore') }}
          </th>
          <th class="col-issues" *ngIf="isColumnVisible('issues')">Issues</th>
          <th class="col-health sortable table__sortable" *ngIf="isDevView() && isColumnVisible('health')" (click)="toggleSort('health')">
            Health{{ sortIcon('health') }}
          </th>
          <th class="col-secondary-health sortable table__sortable" *ngIf="isDevView() && isColumnVisible('health')" (click)="toggleSort('secondaryHealth')">
            Secondary health{{ sortIcon('secondaryHealth') }}
          </th>
          <th class="col-effective-health sortable table__sortable" *ngIf="isColumnVisible('health')" (click)="toggleSort('effectiveHealth')">
            {{ isDevView() ? 'Effective health' : 'Health' }}{{ sortIcon('effectiveHealth') }}
          </th>
          <th
            class="col-realization-gap sortable table__sortable"
            *ngIf="isColumnVisible('realizationGap')"
            [title]="realizationGapColumnHint"
            (click)="toggleSort('realizationGap')"
          >
            Gap{{ sortIcon('realizationGap') }}
          </th>
          <th
            class="col-realization-ratio sortable table__sortable"
            *ngIf="isColumnVisible('realizationRatio')"
            [title]="realizationRatioColumnHint"
            (click)="toggleSort('realizationRatio')"
          >
            Ratio{{ sortIcon('realizationRatio') }}
          </th>
          <th
            class="col-serp-kd sortable table__sortable"
            *ngIf="isColumnVisible('serpKeywordDifficulty')"
            [title]="serpKeywordDifficultyColumnHint"
            (click)="toggleSort('serpKeywordDifficulty')"
          >
            KD{{ sortIcon('serpKeywordDifficulty') }}
          </th>
          <th class="col-demand-claim" *ngIf="isColumnVisible('demandClaim')">Demand claim</th>
          <th class="col-signals" *ngIf="isColumnVisible('signals')">Signals</th>
          <th class="col-clusters" *ngIf="isColumnVisible('clusters')">Cluster</th>
          <th class="col-top-topics" *ngIf="isColumnVisible('topTopics')">Top topics</th>
          <th class="col-topic-class" *ngIf="hasTopicScope && isColumnVisible('topicClass')">
            Class
          </th>
          <th class="col-topic-relevance sortable table__sortable" *ngIf="hasTopicScope && isColumnVisible('topicRelevance')" (click)="toggleSort('topicRelevanceScore')">
            Relevance{{ sortIcon('topicRelevanceScore') }}
          </th>
          <th class="col-topic-weight sortable table__sortable" *ngIf="hasTopicScope && isColumnVisible('topicWeight')" (click)="toggleSort('topicWeight')">
            Weight{{ sortIcon('topicWeight') }}
          </th>
          <th class="col-keywords" *ngIf="isColumnVisible('keywords')">Keywords</th>
          <th class="col-traffic sortable table__sortable" *ngIf="isColumnVisible('estimatedOrganicTraffic')" (click)="toggleSort('estimatedOrganicTraffic')">
            Est. Traffic{{ sortIcon('estimatedOrganicTraffic') }}
          </th>
          <th class="col-date sortable table__sortable" *ngIf="isColumnVisible('analyzedAt')" (click)="toggleSort('analyzedAt')">
            Analyzed{{ sortIcon('analyzedAt') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngTemplateOutlet="inventoryRows; context: { $implicit: pages, bulkSelectPrimary: true }"></ng-container>
      </tbody>
    </table>
  </div>

  <div class="pagination" *ngIf="!isCompareTopicMode && pagination.totalPages > 1">
    <button
      class="btn btn--sm"
      [disabled]="pagination.page <= 1"
      (click)="goToPage(pagination.page - 1)"
    >← Prev</button>

    <span class="page-info">
      Page {{ pagination.page }} of {{ pagination.totalPages }}
    </span>

    <button
      class="btn btn--sm"
      [disabled]="pagination.page >= pagination.totalPages"
      (click)="goToPage(pagination.page + 1)"
    >Next →</button>
  </div>

  <div class="inventory-pages-floating-actions" *ngIf="!isCompareTopicMode && bulkClusterSelectionCount > 0">
    <div class="inventory-bulk-cluster-actions" aria-label="Add pages to cluster">
      <span class="inventory-bulk-cluster-summary">{{ bulkClusterSelectionCount }} page(s) selected</span>
      <label class="inventory-bulk-cluster-label" for="bulk-cluster-select-pages">Add to cluster</label>
      <select
        id="bulk-cluster-select-pages"
        class="input inventory-bulk-cluster-select"
        [(ngModel)]="bulkTargetClusterId"
      >
        <option [ngValue]="null">Choose a cluster…</option>
        <option *ngFor="let c of planClusters" [ngValue]="c.id">{{ c.label }}</option>
      </select>
      <button
        type="button"
        class="btn btn--accent"
        (click)="confirmBulkAddToCluster()"
        [disabled]="!bulkTargetClusterId || isBulkSaving"
      >
        {{ isBulkSaving ? 'Adding…' : 'Add' }}
      </button>
      <label class="inventory-bulk-cluster-label" for="bulk-cluster-remove-select-pages">Remove from cluster</label>
      <select
        id="bulk-cluster-remove-select-pages"
        class="input inventory-bulk-cluster-select"
        [(ngModel)]="bulkRemoveClusterId"
      >
        <option [ngValue]="null">Choose a cluster…</option>
        <option *ngFor="let c of planClusters" [ngValue]="c.id">{{ c.label }}</option>
      </select>
      <button
        type="button"
        class="btn"
        (click)="confirmBulkRemoveFromCluster()"
        [disabled]="!bulkRemoveClusterId || isBulkRemoving"
      >
        {{ isBulkRemoving ? 'Removing…' : 'Remove' }}
      </button>
      <button type="button" class="btn" (click)="clearBulkClusterSelection()">Clear selection</button>
      <button type="button" class="btn" (click)="markBulkSelectionIncluded()" [disabled]="isUpdatingInclusion">
        {{ isUpdatingInclusion ? 'Saving…' : 'Mark included' }}
      </button>
      <button type="button" class="btn" (click)="markBulkSelectionExcluded()" [disabled]="isUpdatingInclusion">
        {{ isUpdatingInclusion ? 'Saving…' : 'Mark excluded' }}
      </button>
      <p class="inventory-bulk-cluster-hint" *ngIf="planClusters.length === 0">
        No clusters yet —
        <button type="button" class="btn btn--bare" (click)="openPlanTabFromBulkHint()">Open Plan</button>
        to add a topic.
      </p>
    </div>
  </div>
</div>

<ng-template #inventoryRows let-pages let-urlCompact="urlCompact" let-compareSimple="compareSimple" let-comparePanel="comparePanel" let-bulkSelectPrimary="bulkSelectPrimary">
  <tr *ngFor="let page of pages; let i = index" class="table__row page-row" (click)="goToUrlDetail(page.url)">
    <td *ngIf="bulkSelectPrimary" class="col-bulk-select" (click)="$event.stopPropagation()">
      <input
        type="checkbox"
        [checked]="isBulkSelected(page.url)"
        (click)="onBulkCheckboxClick(page, pages, i, $event); $event.stopPropagation()"
        [attr.aria-label]="'Select page for cluster: ' + page.url"
      />
    </td>
    <td
      *ngIf="comparePanel === 'compare' && !bulkSelectPrimary"
      class="col-bulk-select col-bulk-select--spacer"
      aria-hidden="true"
    ></td>
    <td
      *ngIf="comparePanel"
      class="col-quick-compare-select"
      (click)="$event.stopPropagation()"
    >
      <input
        type="checkbox"
        [checked]="isQuickCompareSelected(comparePanel, page.url)"
        (change)="toggleQuickCompareSelection(comparePanel, page)"
        (click)="$event.stopPropagation()"
        [attr.aria-label]="'Select this page for quick compare'"
      />
    </td>
    <td
      class="col-url"
      [class.col-url--compact]="urlCompact"
      [class.col-url--compare-full]="compareSimple"
      [title]="page.url"
    >
      <span
        class="url-text"
        [class.url-text--compact]="urlCompact"
        [class.url-text--compare-full]="compareSimple"
      >{{ formatUrl(page.url, !compareSimple) }}</span>
    </td>
    <td class="col-clusters" *ngIf="compareSimple && isColumnVisible('clusters')">
      <div class="clusters-tags" *ngIf="primaryClusterForPage(page) as clusterLabel">
        <span class="badge badge--truncate cluster-tag" [title]="clusterLabel">{{ clusterLabel }}</span>
        <button
          type="button"
          class="top-topic-overflow cluster-overflow"
          *ngIf="clusterOverflowCount(page) > 0"
          (mouseenter)="openClusterPopover(page, $event)"
          (mouseleave)="scheduleClusterPopoverHide()"
          (focus)="openClusterPopover(page, $event)"
          (blur)="scheduleClusterPopoverHide()"
          (click)="$event.stopPropagation()"
          [attr.aria-label]="'Show remaining clusters (' + clusterOverflowCount(page) + ')'"
        >
          +{{ clusterOverflowCount(page) }}
        </button>
      </div>
      <span class="clusters-empty" *ngIf="!primaryClusterForPage(page)">—</span>
    </td>
    <td class="col-top-topics" *ngIf="compareSimple && isColumnVisible('topTopics')">
      <div class="top-topics-pills" *ngIf="topTopicsForPage(page).length > 0">
        <span
          class="badge top-topic-pill"
          *ngFor="let t of topTopicsForPage(page)"
          [ngClass]="topTopicPillClass(t.relevancePct)"
          [title]="t.label + ' (' + t.relevancePct + '%)'"
        >
          {{ t.label }}
        </span>
        <button
          type="button"
          class="top-topic-overflow"
          *ngIf="topTopicsOverflowCount(page) > 0"
          (mouseenter)="openTopTopicsPopover(page, $event)"
          (mouseleave)="scheduleTopTopicsPopoverHide()"
          (focus)="openTopTopicsPopover(page, $event)"
          (blur)="scheduleTopTopicsPopoverHide()"
          (click)="$event.stopPropagation()"
          [attr.aria-label]="'Show remaining topics (' + topTopicsOverflowCount(page) + ')'"
        >
          +{{ topTopicsOverflowCount(page) }}
        </button>
      </div>
      <span class="clusters-empty" *ngIf="topTopicsForPage(page).length === 0">—</span>
    </td>
    <td class="col-score" *ngIf="!compareSimple && isColumnVisible('score')">
      <span class="badge" [ngClass]="scoreClass(page.onpageScore)">
        {{ page.onpageScore }}
      </span>
    </td>
    <td class="col-issues" *ngIf="!compareSimple && isColumnVisible('issues')">
      <span class="issues-badge issues-badge--icons">
        <span
          class="badge badge--pill badge--danger issue-pill"
          *ngIf="page.criticalIssuesCount > 0"
          [title]="page.criticalIssuesCount + ' critical issue' + (page.criticalIssuesCount === 1 ? '' : 's')"
        >
          <span class="issue-pill-icon" aria-hidden="true">⛔</span>
          <span>{{ page.criticalIssuesCount }}</span>
        </span>
        <span
          class="badge badge--pill badge--warning issue-pill"
          *ngIf="page.warningsCount > 0"
          [title]="page.warningsCount + ' warning' + (page.warningsCount === 1 ? '' : 's')"
        >
          <span class="issue-pill-icon" aria-hidden="true">⚠</span>
          <span>{{ page.warningsCount }}</span>
        </span>
        <span
          class="badge badge--pill badge--success issue-pill"
          *ngIf="page.criticalIssuesCount === 0 && page.warningsCount === 0"
          title="No critical issues or warnings"
        >
          Clean
        </span>
      </span>
    </td>
    <td class="col-health" *ngIf="!compareSimple && isDevView() && isColumnVisible('health')">
      <span
        class="status-dot"
        [ngClass]="pageHealthClass(page)"
        [title]="pageHealthTitle(page)"
      >
        {{ pageHealthLabel(page) }}
      </span>
    </td>
    <td class="col-secondary-health" *ngIf="!compareSimple && isDevView() && isColumnVisible('health')">
      <span
        class="status-dot"
        [ngClass]="pageSecondaryHealthClass(page)"
        [title]="pageSecondaryHealthTitle(page)"
      >
        {{ pageSecondaryHealthLabel(page) }}
      </span>
    </td>
    <td class="col-effective-health" *ngIf="!compareSimple && isColumnVisible('health')">
      <span
        class="status-dot"
        [ngClass]="pageEffectiveHealthClass(page)"
        [title]="pageEffectiveHealthTitle(page)"
      >
        {{ pageEffectiveHealthLabel(page) }}
      </span>
    </td>
    <td class="col-realization-gap" *ngIf="!compareSimple && isColumnVisible('realizationGap')">
      <span class="realization-metric" [title]="pageRealizationGapTitle(page)">
        {{ pageRealizationGapLabel(page) }}
      </span>
    </td>
    <td class="col-realization-ratio" *ngIf="!compareSimple && isColumnVisible('realizationRatio')">
      <span class="realization-metric" [title]="pageRealizationRatioTitle(page)">
        {{ pageRealizationRatioLabel(page) }}
      </span>
    </td>
    <td class="col-serp-kd" *ngIf="!compareSimple && isColumnVisible('serpKeywordDifficulty')">
      <span class="realization-metric serp-kd-metric" [title]="pageSerpKeywordDifficultyTitle(page)">
        {{ pageSerpKeywordDifficultyLabel(page) }}
      </span>
    </td>
    <td class="col-demand-claim" *ngIf="!compareSimple && isColumnVisible('demandClaim')">
      <div class="page-demand-cell">
        <span
          class="page-demand-claim"
          [ngClass]="pageDemandClaimClass(page)"
          [title]="isDevView() ? '' : pageDemandClaimTitle(page)"
        >
          {{ pageDemandClaimLabel(page) }}
        </span>
        <div class="page-demand-dev" *ngIf="isDevView()">
          <div class="page-demand-dev-line">Claim: {{ pageDemandClaimSourceConfidence(page) }}</div>
          <div class="page-demand-dev-line">Realization: {{ pageDemandRealizationSourceConfidence(page) }}</div>
          <div class="page-demand-dev-line">Split: {{ pageDemandSplitReasonsText(page) }}</div>
        </div>
      </div>
    </td>
    <td class="col-signals" *ngIf="!compareSimple && isColumnVisible('signals')" (click)="$event.stopPropagation()">
      <span class="page-signals-loading" *ngIf="pageSignalsLoading()">—</span>
      <div class="page-signals" *ngIf="!pageSignalsLoading() && pageSignalsFor(page).length > 0">
        <span
          class="badge badge--pill page-signal-chip"
          *ngFor="let signal of pageSignalsFor(page)"
          [ngClass]="pageSignalChipClass(signal.kind)"
          [title]="signal.title"
        >
          {{ signal.label }}
        </span>
      </div>
      <span class="clusters-empty" *ngIf="!pageSignalsLoading() && pageSignalsFor(page).length === 0">—</span>
    </td>
    <td class="col-clusters" *ngIf="!compareSimple && isColumnVisible('clusters')">
      <div class="clusters-tags" *ngIf="primaryClusterForPage(page) as clusterLabel">
        <span class="badge badge--truncate cluster-tag" [title]="clusterLabel">{{ clusterLabel }}</span>
        <button
          type="button"
          class="top-topic-overflow cluster-overflow"
          *ngIf="clusterOverflowCount(page) > 0"
          (mouseenter)="openClusterPopover(page, $event)"
          (mouseleave)="scheduleClusterPopoverHide()"
          (focus)="openClusterPopover(page, $event)"
          (blur)="scheduleClusterPopoverHide()"
          (click)="$event.stopPropagation()"
          [attr.aria-label]="'Show remaining clusters (' + clusterOverflowCount(page) + ')'"
        >
          +{{ clusterOverflowCount(page) }}
        </button>
      </div>
      <span class="clusters-empty" *ngIf="!primaryClusterForPage(page)">—</span>
    </td>
    <td class="col-top-topics" *ngIf="!compareSimple && isColumnVisible('topTopics')">
      <div class="top-topics-pills" *ngIf="topTopicsForPage(page).length > 0">
        <span
          class="badge top-topic-pill"
          *ngFor="let t of topTopicsForPage(page)"
          [ngClass]="topTopicPillClass(t.relevancePct)"
          [title]="t.label + ' (' + t.relevancePct + '%)'"
        >
          {{ t.label }}
        </span>
        <button
          type="button"
          class="top-topic-overflow"
          *ngIf="topTopicsOverflowCount(page) > 0"
          (mouseenter)="openTopTopicsPopover(page, $event)"
          (mouseleave)="scheduleTopTopicsPopoverHide()"
          (focus)="openTopTopicsPopover(page, $event)"
          (blur)="scheduleTopTopicsPopoverHide()"
          (click)="$event.stopPropagation()"
          [attr.aria-label]="'Show remaining topics (' + topTopicsOverflowCount(page) + ')'"
        >
          +{{ topTopicsOverflowCount(page) }}
        </button>
      </div>
      <span class="clusters-empty" *ngIf="topTopicsForPage(page).length === 0">—</span>
    </td>
    <td class="col-topic-class" *ngIf="hasTopicScope && isColumnVisible('topicClass')">
      <span class="badge topic-class-badge" [ngClass]="topicClassBadgeClass(page.topicClass)">
        {{ topicClassLabel(page.topicClass) }}
      </span>
    </td>
    <td class="col-topic-relevance" *ngIf="hasTopicScope && isColumnVisible('topicRelevance')">
      <span class="badge" [ngClass]="topicWeightClass(page.topicRelevanceScore)">
        {{ formatTopicRelevancePct(page.topicRelevancePct) }}
      </span>
    </td>
    <td class="col-topic-weight" *ngIf="hasTopicScope && isColumnVisible('topicWeight')">
      <span class="badge" [ngClass]="topicWeightClass(page.topicWeight)">
        {{ formatTopicWeight(page.topicWeight) }}
      </span>
    </td>
    <td class="col-keywords" *ngIf="isColumnVisible('keywords')"><span [class.cell-empty]="page.rankedKeywordsCount == null">{{ page.rankedKeywordsCount ?? '—' }}</span></td>
    <td class="col-traffic" *ngIf="isColumnVisible('estimatedOrganicTraffic')"><span [class.cell-empty]="page.estimatedOrganicTraffic == null">{{ page.estimatedOrganicTraffic != null ? (page.estimatedOrganicTraffic | number:'1.0-0') : '—' }}</span></td>
    <td class="col-date" *ngIf="!compareSimple && isColumnVisible('analyzedAt')">{{ timeAgo(page.analyzedAt) }}</td>
  </tr>
</ng-template>

<app-inventory-quick-compare-drawer
  [open]="quickCompareDrawerOpen"
  [primaryUrl]="quickComparePrimaryUrl"
  [compareUrl]="quickCompareCompareUrl"
  [primaryDomainLabel]="selectedDomain"
  [compareDomainLabel]="compareToDomain || ''"
  (closed)="onQuickCompareDrawerClose()"
  (openFullCompare)="onOpenFullCompareFromQuickDrawer()"
/>
<div
  class="top-topic-global-popover"
  *ngIf="topTopicsPopover.open"
  [style.left.px]="topTopicsPopover.left"
  [style.top.px]="topTopicsPopover.top"
  (mouseenter)="cancelTopTopicsPopoverHide()"
  (mouseleave)="scheduleTopTopicsPopoverHide()"
  role="tooltip"
>
  <div class="top-topic-overflow-title">More topics</div>
  <div class="top-topic-overflow-list">
    <span
      class="badge top-topic-pill"
      *ngFor="let t of topTopicsPopover.topics"
      [ngClass]="topTopicPillClass(t.relevancePct)"
    >
      {{ t.label }} ({{ t.relevancePct }}%)
    </span>
  </div>
</div>
<div
  class="top-topic-global-popover cluster-global-popover"
  *ngIf="clusterPopover.open"
  [style.left.px]="clusterPopover.left"
  [style.top.px]="clusterPopover.top"
  (mouseenter)="cancelClusterPopoverHide()"
  (mouseleave)="scheduleClusterPopoverHide()"
  role="tooltip"
>
  <div class="top-topic-overflow-title">More clusters</div>
  <div class="top-topic-overflow-list">
    <span class="badge badge--truncate cluster-tag" *ngFor="let name of clusterPopover.clusters">{{ name }}</span>
  </div>
</div>
  </ng-container>
</div>
